// en, de, fr, pt
export default {
	en: {
		Ativo: 'Active',
		PoliticaPrivacidade: 'Privacy Policy',
		SelecionarTodos: 'Select All',
		DesselecionarTodos: 'Unselect All',
		Dashboard: 'Dashboard',
		DashboardVeiculos: 'Fleet Dashboard',
		DashboardMotoristas: 'Driver Dashboard',
		DashboardTelemetria: 'Telemetry Dashboard',
		DashboardCameras: 'Cameras Dashboard',
		DashboardDespesas: 'Expenses Dashboard',
		Periodo: 'Período',
		Sim: 'Yes',
		Nao: 'No',
		Dia_Semana_Seg: 'Segunda',
		Dia_Semana_Ter: 'Terça',
		Dia_Semana_Qua: 'Quarta',
		Dia_Semana_Qui: 'Quinta',
		Dia_Semana_Sex: 'Sexta',
		Dia_Semana_Sab: 'Sabado',
		Dia_Semana_Dom: 'Domingo',
		Atencao: 'Attention',
		Erro: 'Error',
		Mapa: 'Map',
		Grid: 'Grid',
		Percursos: 'Course',
		Avisos: 'Alerts',
		Tipo_Aviso: 'Alert Type',
		Frotas: 'Fleet',
		Viagens: 'Travels',
		Pneus: 'Tires',
		Roteirizacao: 'Routing',
		Relatorios: 'Reporting',
		Configuracao: 'Setup',
		Bloqueio: 'Block',
		Veiculo: 'Car',
		Veiculos: 'Cars',
		Placa: 'Plate',
		Motorista: 'Driver',
		KmhParado: 'Km/h - stopped',
		Sensor: 'Sensor',
		Localizacao: 'Location',
		Parado: 'Stopped',
		Desatualizado: 'Out of date',
		AlertaParado: 'Stopped Alert',		
		ComSensor: 'With Sensor',		
		Acesso: 'Login',
		MensagemAcesso: 'Welcome back, please login to your account.',
		TelaLogin_phCPFCNPJ: 'Enter the CPF or CNPJ or login',
		TelaLogin_lLembrarSenha: 'Remember Me',
		TelaLogin_lEsqueciSenha: 'Forgot Password ?',
		TelaLogin_lEntrar: 'Login',
		TelaLogin_lTrocarSenha: 'Change Password',		
		Mensagem_LoginInvalido: 'The login and / or password entered is invalid.',
		Mensagem_Login_Bloqueado: '',
		NenhumVeiculoEncontrado: '',
		NenhumEquipamentoEncontrado: 'Nenhum equipamento encontrado',
		NenhumMotoristaEncontrado: 'Nenhum motorista encontrado',
		Tooltipo_Exibir_Cidade: 'Exibir o nome da cidade',
		Tooltipo_Exibir_Endereco: 'Exibir o endereço completo',
		Tooltip_Qtd_Veiculos: 'Quantidade de veículos rastreados',
		Tooltip_Filtro_Parados: 'Exibir somente os veículos parados',
		Tooltip_Filtro_Desatualizados: 'Exibir somente os veículos desatualizados',
		Tooltip_Filtro_AlertaParados: 'Exibir somente os veículos com alerta de tempo parado',
		Tooltip_Filtro_ComSensor: 'Exibir somente os veículos com sensor',
		Tooltip_Filtro_ComControleViagem: 'Exibir somente os veículos que estão em Viagem Iniciada',
		Aviso: 'Alert',
		Descricao: 'Description',
		Hora: 'Time',
		AvisosDoDia: 'Todays Alert',
		Tooltip_Qtd_Avisos: 'Quantidade de avisos',
		Mensagem_Ver_Todos_Avisos_Dia: 'Ver todos os avisos do dia',
		Cidade: 'City',
		PopUp_AgruparPorCidade: 'Veículos por cidade',
		Pesquisa: 'Search',
		LimparFiltros: 'Clean filters',
		ExportarParaCSV: 'Exportar para CSV',
		Novo: 'Novo',
		Filtros: 'Filtros',
		Qtd: 'Qty',
		Divisao: 'Group',
		Divisao_Veiculo: 'Divisão de Veículos',
		Divisao_Motorista: 'Drivers Group',
		Imprimir: 'Imprimir',
		Agrupar: 'Agrupar',
		Fechar: 'Fechar',
		PontosInteresse: 'Pontos de Interesse',
		AgGrid_Contains: 'Contains',
		AgGrid_notContains: 'Not Contains',
        AgGrid_startsWith: 'Starts with',
        AgGrid_endsWith: 'Ends with',
        AgGrid_andCondition: 'AND',
        AgGrid_orCondition: 'OR',
        AgGrid_filters: 'Filters',
        AgGrid_equals: 'Equals',
		AgGrid_notEqual: 'NotEqual',
		AgGrid_filterOoo: 'Filtrar ...',
		Exibidos: 'Exibido(s)',
		Gravar_Exibidos:'Gravar exibidos',
		Perimetros: 'Perímetros',
		Btn_Gravar: 'Save',
		Btn_Limpar: 'Limpar',
		Btn_Voltar: 'Voltar',
		Btn_Excluir: 'Excluir',
		Btn_Localizar_Endereco: 'Localiza Endereço',
		Btn_Fechar: 'Fechar',
		Btn_OK: 'OK',
		Btn_CentralizarPerimetro: 'Centralizar Perímetro',
		Btn_Importar_KML: 'Importar KML',
		Btn_Ativar: 'Ativar',
		Btn_Desativar: 'Desativar',
		Btn_Bloquear: 'Ativar',
		Btn_Desbloquear: 'Desativar',
		Btn_Inserir: 'Inserir',
		Btn_InserirLimpar: 'Inserir e Limpar',
		Btn_Importar: 'Importar',
		Cor_Localidade: 'Cor Localidade',
		Titulo_Corrigir_Erros: 'Please correct the following error(s):',
		Mensagem_Erro_Obrigatorio: 'required',
		Mensagem_Erro_Invalido: 'invalid',
		TelaMotorista_lNome: 'Nome',
		TelaMotorista_lMatricula: 'Matricula',
		TelaMotorista_lCPF: 'CPF',
		TelaMotorista_lRG: 'RG',
		TelaMotorista_lCNH: 'CNH',
		TelaMotorista_lCategoriaCNH: 'Categoria',
		TelaMotorista_lValidadeCNH: 'Validade CNH',
		TelaMotorista_lValidadeExameToxicologico: 'Validade Exame Toxicológico',
		TelaMotorista_lValidadeMOPP: 'Validade MOPP',
		TelaMotorista_lChaveiroCartao: 'Chaveiro/Cartão',
		TelaMotorista_lDataHoraInicioUsoCartao: 'Data/Hora Início do uso do chaveiro/cartão',
		TelaMotorista_lSenha: 'Senha',
		TelaMotorista_lEnderecos: 'Endereços',
		TelaMotorista_lTelefones: 'Telefones',
		TelaMotorista_lAtivo: 'Ativo',
		TelaMotorista_Mensagem_Erro_1: 'Informe a data e a hora de início de uso do chaveiro com este motorista',
		TelaMotorista_lImportacaoInstrucao: 'O arquivo CSV deve ter como separador o ; (ponto e virgula) e a sequencia de coluna é NOME ;  MATRICULA ; CPF ; RG ; CNH ; CATEGORIA ; VALIDADE CNH (formato dd/MM/yyyy) ; ENDERECO; TELEFONES ; CODIGO CHAVEIRO ; DATA ATIVACAO (formato dd/MM/yyyy HH:mm:ss) ;',
		TelaMotorista_lImportacaoInstrucao2: 'A primeira linha do arquivo é considerada como cabeçalho.',
		TelaMotorista_lImportacaoInstrucao3: 'Os motoristas serão atualizados caso tenha codigo do chaveiro, a matricula, cpf ou nome já cadastrado previamente. Para cadastrar o motorista com chaveiro a data de ativação do chaveiro é obrigatória. Se informado apenas o código do chaveiro, a plataforma apenas tentará atualizar.',
		TelaCorLocalidade_lNome: 'Nome da Localidade',	
		TelaDivisao_lCodigo: 'Codigo',
		TelaDivisao_lNome: 'Nome',	
		TelaCategoriaAviso_lNome: 'Nome',	
		TelaCategoriaAviso_lTipo: 'Tipo',
		TelaPontuacaoAviso_lTipoAviso: 'Tipo do Aviso',
		TelaPontuacaoAviso_lTipoCategoria: 'Categoria do Aviso',
		TelaPontuacaoAviso_lPontuacao: 'Pontuação',
		Menu_Alterar_Veiculo: 'Alteração Veículo',
		Menu_Alterar_Dados_Contato_Veiculo: 'Alteração Dados Contato',
		TelaAlterarVeiculo_lCategoria: 'Categoria',
		TelaAlterarVeiculo_lDivisao: 'Divisão',
		TelaAlterarVeiculo_lTipoVeiculo: 'Tipo Veículo',
		TelaAlterarVeiculo_lMarca: 'Marca',
		TelaAlterarVeiculo_lModelo: 'Modelo',
		TelaAlterarVeiculo_lModeloOutro: 'Outro Modelo',
		TelaAlterarVeiculo_lPlaca: 'Placa',
		TelaAlterarVeiculo_lMesVencto: 'Mês Vencto',
		TelaAlterarVeiculo_lLabel: 'Label',
		TelaAlterarVeiculo_lAnoFabricacao: 'Ano Fabricação',
		TelaAlterarVeiculo_lAnoModelo: 'Ano Modelo',
		TelaAlterarVeiculo_lCor: 'Cor',
		TelaAlterarVeiculo_lChassi: 'Chassi', 
		TelaAlterarVeiculo_lRenavam: 'Renavam',  	
		TelaAlterarVeiculo_lCondutor: 'Condutor', 
		TelaAlterarVeiculo_lKMl: 'KM/l', 
		TelaAlterarVeiculo_lLh: 'L/h', 
		TelaAlterarVeiculo_lHorimetro: 'Horímetro', 
		TelaAlterarVeiculo_lOdometro: 'Odômetro', 
		TelaAlterarVeiculo_lSenhaAcessoIndividual: 'Senha de Acesso Individual', 
		TelaAlterarVeiculo_lVelocidadeMinima: 'Velocidade Mínima km/h', 
		TelaAlterarVeiculo_lVelocidadeMaxima: 'Velocidade Máxima km/h', 
		TelaAlterarVeiculo_lLabelControleHorario: 'Controlar horários de uso dos veículos',
		TelaAlterarVeiculo_lMensagemControleHorario: 'Informe os horários permitidos de utilização do veículo',
		TelaAlterarVeiculo_lAvisarExcessoVelocidade: 'Avisar Excesso Velocidade',
		TelaAlterarVeiculo_lAvisarExcessoVelocidadeVia: 'Avisar Excesso Velocidade na Cidade',
		TelaAlterarVeiculo_lVeiculoEmManutencao: 'Veículo em manutenção',
		TelaAlterarVeiculo_lAvisarSaidaPerimetro: 'Avisar Saída Perímetro',
		TelaAlterarVeiculo_lAvisarVeiculoParado: 'Avisar Veículo Parado',
		TelaAlterarVeiculo_lTempoParada: "Tempo parada em minutos",
		TelaAlterarVeiculo_lLimitePressaoAcelerador: "Limite Pressão Acelerador",
		TelaAlterarVeiculo_lSelecionarPerimetro: "Selecione o perímetro",
		TelaAlterarVeiculo_lRPMMax: "RPM Máximo",
		TelaAlterarVeiculo_lTempoDirecaoMaximo: "Tempo Máximo de Direção",
		TelaAlterarVeiculo_lLigarAncoragem: "Ligar Ancoragem",
		TelaAlterarVeiculo_lAvisarVeiculoLigado: "Avisar Veículo Ligado",
		TelaAlterarVeiculo_lAvisarVeiculoDesligado: "Avisar Veículo Desligado",
		TelaAlterarVeiculo_lAvisarVeiculoParadoLigado: "Avisar Veículo Parado Ligado?",
		TelaAlterarVeiculo_lResponsavel1: "Responsável 1",
		TelaAlterarVeiculo_lResponsavel2: "Responsável 2",
		TelaAlterarVeiculo_lEmail1: "Email 1",
		TelaAlterarVeiculo_lEmail2: "Email 2",
		TelaAlterarVeiculo_lCelular1: "Celular 1",
		TelaAlterarVeiculo_lCelular2: "Celular 2",
		TelaAlterarVeiculo_lContatoEmergencia: "Contatos de Emergência",
		TelaAlterarVeiculo_lHoraGeracao: "Hora Geração",
		TelaAlterarVeiculo_lAnexarMapa: "Anexar Mapa ?",
		TelaAlterarVeiculo_lEnviarFinalSemana: "Enviar final de semana ?",
		TelaAlterarVeiculo_lTempoMinimoParada: "Tempo Mínimo ( minutos)",
		TelaAlterarVeiculo_lSoParadaLigado: "Só paradas ligado ?",
		TelaAlterarVeiculo_lSoEmPontosInteresse: "Só em pontos de interesse ?",
		TelaAlterarVeiculo_MensagemRota: 'Parâmetros utilizados na roteirização e aplicativo Minha Rota',
		TelaAlterarVeiculo_lSenhaAplicativoEntrega: 'Senha aplicativo de entrega',
		TelaAlterarVeiculo_lCapacidadePeso: 'Capacidade - Peso',
		TelaAlterarVeiculo_lCapacidadeVolume: 'Capacidade - Volume',
		TelaAlterarVeiculo_lCustoPorKM: 'Custo por KM',
		TelaAlterarVeiculo_lQtdMaximaItinerarios: 'Quantidade máxima de itinerários',
		TelaAlterarVeiculo_lLabelHorarioBloqueio: 'Bloqueio automático do veículo',
		TelaAlterarVeiculo_lMensagemHorarioBloqueio: 'Informe os horários que o veículo deve ser bloqueado e desbloqueado',
		TelaAlterarVeiculo_lMensagemVeiculoSemBloqueio: 'Este veículo não possui o acessório de bloqueio instalado.',
		TelaAlterarVeiculo_Btn_RepetirSegunda: 'Repetir Horário de Segunda',
		TelaAlterarVeiculo_Btn_RepetirSegundaAteSexta: 'Repetir Horário de Segunda até Sexta',
		TelaAlterarVeiculo_lCapacidadeTanque: 'Capacidade tanque ( litros )',
		TelaAlterarVeiculo_lAcessosDisponveis: 'ACESSOS DISPONÍVEIS',
		TelaAlterarVeiculo_lAcessosSelecionados: 'ACESSOS SELECIONADOS',
		TelaAlterarVeiculo_lTiposCombustiveisDisponiveis: 'TIPOS DE COMBUSTÍVEIS DISPONÍVEIS',
		TelaAlterarVeiculo_lTiposCombustiveisDoVeiculo: 'TIPOS DE COMBUSTÍVEIS DO VEÍCULO',
		TelaAlterarVeiculo_lMensagemFaixasRPM: 'Configure as faixas de RPM do veículo',
		TelaAlterarVeiculo_lFaixa1RPM: 'Faixa 1',
		TelaAlterarVeiculo_lFaixa2RPM: 'Faixa 2',
		TelaAlterarVeiculo_lFaixa3RPM: 'Faixa 3',
		TelaAlterarVeiculo_lFaixa4RPM: 'Faixa 4',
		TelaAlterarVeiculo_lFaixa5RPM: 'Faixa 5',
		TelaAlterarVeiculo_lAcimaFaixa5RPM: 'Acima da Faixa 5',
		TelaAlterarVeiculo_lAtualizacaoRPMPorMinuto: 'Atualizações por minuto',
		TelaAlterarVeiculo_Msg1_PopupMotoristas: 'Selecione o novo motorista para o veículo.',
		TelaAlterarVeiculo_Msg2_PopupMotoristas: 'Clique nos motoristas que são autorizados a utilizar o veículo.',
		TelaAlterarVeiculo_Mensagem_Erro_1: 'Acesso já cadastrado',
		TelaAlterarVeiculo_Mensagem_Erro_2: 'Tipo de combustível já selecionado',
		TelaAlterarVeiculo_Mensagem_Erro_3: 'Email 1 de envio do relatório de paradas',
		TelaAlterarVeiculo_Mensagem_Erro_4: 'Hora de envio do relatório de paradas',
		TelaAlterarVeiculo_Mensagem_Erro_5: 'Informe pelo menos um email para o envio do do relatório de paradas',
		TelaAlterarVeiculo_Mensagem_Erro_6: 'Email 2 de envio do relatório de paradas',
		TelaAlterarVeiculo_Mensagem_Erro_7: 'Email 1 de avisos',
		TelaAlterarVeiculo_Mensagem_Erro_8: 'Email 2 de avisos',
		TelaAlterarVeiculo_Mensagem_Erro_9: 'Informe o horário permitido para pelo menos um dia.',
		TelaAlterarVeiculo_Mensagem_Erro_10: 'Horário inválido de Segunda.',
		TelaAlterarVeiculo_Mensagem_Erro_11: 'Horário inválido de Terça.',
		TelaAlterarVeiculo_Mensagem_Erro_12: 'Horário inválido de Quarta.',
		TelaAlterarVeiculo_Mensagem_Erro_13: 'Horário inválido de Quinta.',
		TelaAlterarVeiculo_Mensagem_Erro_14: 'Horário inválido de Sexta.',
		TelaAlterarVeiculo_Mensagem_Erro_15: 'Horário inválido de Sábado.',
		TelaAlterarVeiculo_Mensagem_Erro_16: 'Horário inválido de Domingo.',
		TelaAlterarVeiculo_Mensagem_Erro_17: 'Informe o horário de bloqueio para pelo menos um dia.',
		TelaAlterarVeiculo_Mensagem_Erro_18: 'Horário de bloqueio inválido de Segunda.',
		TelaAlterarVeiculo_Mensagem_Erro_19: 'Horário de bloqueio inválido de Terça.',
		TelaAlterarVeiculo_Mensagem_Erro_20: 'Horário de bloqueio inválido de Quarta.',
		TelaAlterarVeiculo_Mensagem_Erro_21: 'Horário de bloqueio inválido de Quinta.',
		TelaAlterarVeiculo_Mensagem_Erro_22: 'Horário de bloqueio inválido de Sexta.',
		TelaAlterarVeiculo_Mensagem_Erro_23: 'Horário de bloqueio inválido de Sábado.',
		TelaAlterarVeiculo_Mensagem_Erro_24: 'Horário de bloqueio inválido de Domingo.',
		TelaAlterarVeiculo_Mensagem_Erro_25: 'Valor inválido para o mês de vencimento da placa. Digite um numero entre 1 e 12.',
		TelaAlterarVeiculo_Mensagem_Erro_26: 'Valor inválido para o ano de fabricação. Digite um valor acima de 1900.',
		TelaAlterarVeiculo_Mensagem_Erro_27: 'Valor inválido para o ano do modelo. Digite um valor acima de 1900.',
		TelaAlterarVeiculo_Mensagem_Erro_28: 'O Tempo Máximo de Direção deve ser de pelo menos 60 minutos.',	
		TelaAlterarVeiculo_Mensagem_Erro_29: 'O início da faixa {p1} precisa ter o valor menor que o fim da faixa {p2}',
		TelaAlterarVeiculo_Mensagem_Erro_30: 'A faixa {p1} não pode ter interseção de valores com a faixa {p2}',
		TelaAlterarVeiculo_Mensagem_Erro_31: 'Informe o perímetro',	
		TelaAlterarVeiculo_Mensagem_Erro_32: 'Informe a velocidade mínima para considerar transito em horário não permitido',
		TelaAlterarVeiculo_MensagemRelatorioDiario: 'Preencha os dados dessa aba se você deseja receber um relatório diário com as paradas do dia anterior deste veículo.',
		TelaPerimetro_lNome: 'Nome',	
		TelaPerimetro_lPerimetro: 'Perímetro',	
		TelaPerimetro_Mensagem: 'Informe o endereço para pesquisar',	
		TelaPerimetro_Mensagem_Erro_1: 'O perímetro deve conter pelo menos 3 pontos no mapa',	
		Menu_Perimetro: 'Perímetros',
		Mensagem_EnderecoNaoEncontrado: 'Endereço não encontrado',
		Menu_Atuadores: 'Atuadores',
		TelaAtuadores_Mensagem_AtivarSaida2: 'Selecione o veículo para ativar a saída 2',
		TelaAtuadores_Mensagem_AtivarSaida3: 'Selecione o veículo para ativar a saída 3',
		TelaAtuadores_lSaida2: 'Saída 2',
		TelaAtuadores_lSaida3: 'Saída 3',
		TelaBloqueio_Mensagem_BloquearDesbloquear: 'Selecione o veículo para bloquear/desbloquear',
		TelaBloqueio_lSenha: 'Informe a senha',
		TelaRelatorio_lPeriodoViagem: 'Período da Viagem',
		TelaRelatorio_lTipoDespesa: 'Tipo de Despesa',
		TelaRelatorio_lTipoReceita: 'Tipo de Receita',
		TelaRelatorio_lFornecedor: 'Fornecedor',
		TelaRelatorio_lCliente: 'Cliente',
		TelaRelatorio_lColunasDisponiveis: 'Colunas Disponíveis',
		TelaRelatorio_lColunasSelecionadas: 'Colunas Selecionadas',
		TelaRelatorio_lGrupoDespesa: 'Grupo Despesa',
		TelaRelatorio_lGrupoReceita: 'Grupo Receita',
		TelaRelatorio_lCategoriaPontoInteresse: 'Grupo Ponto de Interesse',
		TelaPessoasRIFD_lMatricula: 'Matrícula',
		TelaPessoasRIFD_lNome: 'Nome',
		TelaPessoasRIFD_lCodigoChaveiro: 'Codigo Chaveiro/Cartão',
		TelaPessoasRIFD_lStatus: 'Status',
		TelaPessoasRIFD_lSetor: 'Setor',
		TelaAlterarVeiculoLote_lVeiculosDisponiveis: 'Veículos Disponíveis',
		TelaAlterarVeiculoLote_lVeiculosSelecionados: 'Veículos Selecionados',
		TelaAlterarVeiculoLote_Mensagem_Erro_1: 'Selecione pelo menos um veículo.',
		TelaCategoriaveiculo_lMenu: 'Categorias Veículos',
		TelaCategoriaveiculo_lDescricao: 'Descrição',
		TelaCategoriaveiculo_lControladoPor: 'Controlado Por',
		TelaCategoriaveiculo_lAroPneus: 'Aro Pneus',
		TelaCategoriaveiculo_lNumeroEstepes: 'Quantidade Estepes',
		TelaCategoriaveiculo_lEixos: 'Eixos',
		TelaCategoriaveiculo_lMensagem_Erro1: "Informe pelo menos 2 eixos",
		TelaCategoriaveiculo_lMensagem_Erro2p1: "O eixo ",
		TelaCategoriaveiculo_lMensagem_Erro2p2: " precisa ter pelo menos dois pneus selecionados.",
		TelaAgendaEventos_lTipo: 'Tipo',
		TelaAgendaEventos_lVeiculo: 'Veículo',
		TelaAgendaEventos_lNome: 'Nome',
		TelaAgendaEventos_lDescricao: 'Descrição',
		TelaAgendaEventos_lStatus: 'Status',
		TelaAgendaEventos_lEmail: 'E-mail',
		TelaAgendaEventos_lParametros: 'Parâmetros',
		TelaAgendaEventos_lDataEvento: 'Data do Evento',
		TelaAgendaEventos_lKM: 'KM',
		TelaAgendaEventos_lHorimetro: 'Horímetro',
		TelaAgendaEventos_lEnvioEmail: 'E-mail enviado às',
		TelaAgendaEventos_lHoraCadastro: 'Cadastrado às',
		TelaAgendaEventos_lTipoItemAgendaEvento: 'Tipo Item Evento',
		Menu_AgendaEventos: 'Agenda de Eventos',
		Menu_Despesas: 'Despesas',
		Menu_Receitas: 'Receitas',
		Menu_TipoDespesas: 'Tipo Despesas',
		Menu_TipoReceitas: 'Tipo Receitas',
		Menu_Fornecedores: 'Fornecedores',
		Menu_CateogoriaPontoInteresse: 'Grupo Ponto de Interesse',
		Menu_PontoInteresse: 'Ponto de Interesse',
		Menu_PontoRotograma: 'Ponto de Rotograma',
		Menu_ImportarPontoInteresse: 'Importar Pontos de Interesse',
		Menu_TanquesCombustivel: 'Tanques de Combustível',
		Menu_CompraCombustivel: 'Compras de Combustível',
		Menu_MovimentacaoCombustivel: 'Movimentações de Combustível',
		Menu_Tipo_Item_Agenda_Eventos: 'Tipo Item Eventos',
		Menu_Tipo_Ocorrencia_Veiculos: 'Tipo Ocorrência de Veículos',
		Menu_Ocorrencia_Veiculos: 'Ocorrência de Veículos',
		TelaFornecedores_lNome: 'Nome',
		TelaFornecedores_lRazaoSocial: 'Razão Social',
		TelaFornecedores_lCPFCNPJ: 'CPF/CNPJ',
		TelaFornecedores_lEndereco: 'Endereço',
		TelaFornecedores_lTelefone: 'Telefone',
		TelaFornecedores_lEmail: 'E-mail',
		TelaFornecedores_lIsCliente: 'Cliente',
		TelaFornecedores_lIsFornecedor: 'Fornecedor',
		TelaFornecedores_lTextoImportacao: 'Importação de favorecidos por arquivo',
		TelaFornecedores_lImportacaoInstrucao: 'O arquivo CSV deve ter como separador o ; (ponto e virgula) e a sequencia de coluna é NOME ; CNPJ OU CPF; ENDEREÇO ; TELEFONE ; EMAIL ; SE CLIENTE ; SE FORNECEDOR . A primeira linha do arquivo é considerada como cabeçalho. Para as colunas SE CLIENTE ou SE FORNECEDOR, utilizar a letra S para SIM e N para não. ',
		TelaCategoriaPontoInteress_lNome: 'Nome',
		TelaCategoriaPontoInteress_lDescricao: 'Descrição',
		TelaCategoriaPontoInteress_lIcone: 'Icone',
		TelaReceitas_lVeiculo: 'Veículo',
		TelaReceitas_lTipo: 'Tipo',
		TelaReceitas_lRota: 'Rota',
		TelaReceitas_lCliente: 'Cliente',
		TelaReceitas_lNome: 'Nome',
		TelaReceitas_lDescricao: 'Descrição',
		TelaReceitas_lData: 'Data',
		TelaReceitas_lValor: 'Valor',
		TelaReceitas_lQuantidade: 'Quantidade',
		TelaReceitas_lMotorista: 'Motorista',
		TelaReceitas_Msg1_PopupMotoristas: 'Selecione o motorista',
		TelaReceitas_Msg1_PopupRotas: 'Selecione a rota',
		PopUpRotas_lPedido: 'Pedido',
		TelaDespesas_lVeiculo: 'Veículo',
		TelaDespesas_lTipo: 'Tipo',
		TelaDespesas_lRota: 'Rota',
		TelaDespesas_lIdentificador: 'Identificador',
		TelaDespesas_lViagem: 'Viagem',
		TelaDespesas_lFornecedor: 'Fornecedor',
		TelaDespesas_lGrupo: 'Grupo',
		TelaDespesas_lNome: 'Nome',
		TelaDespesas_lDescricao: 'Descrição',
		TelaDespesas_lData: 'Data',
		TelaDespesas_lDataPagamento: 'Data Pagamento',
		TelaDespesas_lPeriodo: 'Período',
		TelaDespesas_lValor: 'Valor',
		TelaDespesas_lQuantidade: 'Quantidade',
		TelaDespesas_lMotorista: 'Motorista',
		TelaDespesas_lTipoCombustivel: 'Tipo Combustível',
		TelaDespesas_lTanqueCombustivel: 'Tanque Combustível',
		TelaDespesas_lOdometro: 'Odômetro',
		TelaDespesas_lHorimetro: 'Horímetro',
		TelaDespesas_lNotaFiscal: 'Nota Fiscal',
		TelaDespesas_Msg1_PopupMotoristas: 'Selecione o motorista',
		TelaDespesas_Msg1_PopupRotas: 'Selecione a rota',
		TelaTanqueCombustivel_lNumero: 'Número',
		TelaTanqueCombustivel_lTipoCombustivel: 'Tipo Combustível',
		TelaTanqueCombustivel_lLocalizacao: 'Localização',
		TelaTanqueCombustivel_lCapacidade: 'Capacidade',
		TelaTanqueCombustivel_lEstoqueAtual: 'Estoque Atual',
		TelaTanqueCombustivel_lEstoqueMinimo: 'Estoque Mínimo',
		TelaTanqueCombustivel_lPrecoMedio: 'Preço Médio',
		TelaTanqueCombustivel_lDescricao: 'Descrição',
		TelaTanqueCombustivel_lCodigoSistemaTerceiro: 'Código do Sistema de Terceiro',
		TelaCompraCombustivel_lNotaFiscal: 'Nota Fiscal',
		TelaCompraCombustivel_lNumeroTanqueCombustivel: 'Número Tanque de Combustível',
		TelaCompraCombustivel_lFornecedor: 'Fornecedor',
		TelaCompraCombustivel_lTanqueCombustivel: 'Tanque de Combustível',
		TelaCompraCombustivel_lQuantidade: 'Quantidade',
		TelaCompraCombustivel_lValorTotal: 'Valor Total',
		TelaCompraCombustivel_lDataCompra: 'Data da Compra',
		TelaMovimentacaoCombustivel_lDataCompra: 'Data da Movimentação',
		TelaMovimentacaoCombustivel_lQuantidade: 'Quantidade',
		TelaMovimentacaoCombustivel_lNumeroTanqueCombustivelOrigem: 'Número Tanque de Combustível Origem',
		TelaMovimentacaoCombustivel_lNumeroTanqueCombustivelDestino: 'Número Tanque de Combustível Destino',
		TelaMovimentacaoCombustivel_lTanqueCombustivelOrigem: 'Tanque de Combustível Origem',
		TelaMovimentacaoCombustivel_lTanqueCombustivelDestino: 'Tanque de Combustível Destino',
		TelaPontoInteresse_lGrupo: 'Grupo',
		TelaPontoInteresse_lCodigo: 'Código',
		TelaPontoInteresse_lNome: 'Nome',
		TelaPontoInteresse_lDescricao: 'Descrição',
		TelaPontoInteresse_lRaio: 'Raio',
		TelaPontoInteresse_lIdentificar: 'Identificar',
		TelaPontoInteresse_lEnviarAlerta: 'Enviar Alerta',
		TelaPontoInteresse_lInicioFimRota: 'Início/Fim Rota',
		TelaPontoInteresse_lIcone: 'Icone',
		TelaPontoInteresse_lTipo: 'Tipo',
		TelaPontoInteresse_lPoligono: 'Poligono',
		TelaPontoInteresse_lCirculo: 'Círculo',		
		TelaPontoInteresse_lLatitude: 'Latitude',
		TelaPontoInteresse_lLongitude: 'Longitude',
		TelaPontoInteresse_lRestricoes: 'Restrições',
		TelaPontoInteresse_lHorarioInicial: 'Horário Inicial',
		TelaPontoInteresse_lHorarioFinal: 'Horário Final',
		TelaPontoInteresse_lLimiteVelocidade: 'Limite Velocidade',
		TelaPontoInteresse_lAvisoTempoPermanencia: 'Tempo de Permanência',
		TelaPontoInteresse_lAtivo: 'Ativo',
		TelaPontoInteresse_lFaixaPermanenciaVerde: 'Faixa Verde',
		TelaPontoInteresse_lFaixaPermanenciaVerdeInicio: 'Início da Faixa Verde',
		TelaPontoInteresse_lFaixaPermanenciaVerdeFim: 'Fim da Faixa Verde',
		TelaPontoInteresse_lFaixaPermanenciaAmarela: 'Faixa Amarela',
		TelaPontoInteresse_lFaixaPermanenciaAmarelaInicio: 'Início da Faixa Amarela',
		TelaPontoInteresse_lFaixaPermanenciaAmarelaFim: 'Fim da Faixa Amarela',
		TelaPontoInteresse_lFaixaPermanenciaVermelha: 'Faixa Vermelha',
		TelaPontoInteresse_lFaixaPermanenciaVermelhaInicio: 'Início da Faixa Vermelha',
		TelaPontoInteresse_lFaixaPermanenciaVermelhaFim: 'Fim da Faixa Vermelha',
		TelaPontoInteresse_lIntervaloEmMinutos: 'Intervalo em Minutos',
		TelaMensagemTeclado_lVeiculo: 'Veículo',
		TelaMensagemTeclado_lMotorista: 'Motorista',
		TelaMensagemTeclado_lTipoMensagem: 'Tipo',
		TelaMensagemTeclado_lMensagem: 'Mensagem',
		TelaMensagemTeclado_lTempoAlertaDescanso: 'Tempo para Alerta',
		TelaMensagemTeclado_lDataHora: 'Data/Hora',
		TelaMensagemTeclado_lLocalizacao: 'Localização',
		TelaMensagemTeclado_lJustificativa: 'Justificativa',
		TelaMensagemTeclado_Msg1_PopupMotoristas: ' Selecione o motorista do evento',
		TelaMensagemTeclado_lGerar: 'Gerar',
		TelaMensagemTeclado_lSenha: 'Senha',
		TelaMensagemTeclado_lContraSenha: 'Contra-Senha',
		TelaGrupoveiculo_lNome: 'Nome',
		TelaGrupoveiculo_lLogin: 'Login',
		TelaGrupoveiculo_lSenha: 'Senha',
		TelaGrupoveiculo_lDescricao: 'Descrição',
		TelaGrupoveiculo_lPermissoes: 'Permissões',
		TelaGrupoveiculo_lMaster: 'Master',
		TelaGrupoveiculo_lPodeSeAlterar: 'Pode se Alterar',
		TelaGrupoveiculo_lPodeBloquear: 'Pode Bloquear',
		TelaGrupoveiculo_lVisualizarRelatorios: 'Visualizar Relatórios',
		TelaGrupoveiculo_lVisualizarPercursos: 'Visualizar Percursos',
		TelaGrupoveiculo_lVisualizarAvisos: 'Viaualizar Avisos',
		TelaGrupoveiculo_lVersaoSistema: 'Versão do Sistema',
		Menu_ControleViagens: 'Controle de Viagens',
		Menu_ControleEntradaSaida: 'Controle de Entrada e Saída',
		Menu_ControleRotasViagens: 'Rotas de Viagens',
		Menu_ControleZonasViagens: 'Zonas de Viagens',
		Menu_ControleEquipamentosViagens: 'Equipamentos de Viagens',
		Menu_ControleViagens_EventosMonitriip: 'Eventos do Monitriip',
		TelaZonasViagens_lNome: 'Nome',
		TelaControleViagemRapida_lPontoInteresse : 'Ponto de Interesse',
		TelaRotasControleViagem_lNome: 'Nome',
		TelaRotasControleViagem_msg1: 'Informe um endereço ou selecione um ponto de interesse',
		TelaRotasControleViagem_lNovoLocal: 'Local',
		TelaRotasControleViagem_lPontoInteresse: 'Ponto de Interesse',
		TeleControleViagem_lStatusViagem: 'Status Viagem',
		TeleControleViagem_lDataViagem: 'Data',
		TeleControleViagem_lIdentificador: 'Identificador',
		TeleControleViagem_lMotorista: 'Motorista',
		TeleControleViagem_lAjudantes: 'Ajudantes',
		TeleControleViagem_lZona: 'Zona',
		TeleControleViagem_lDataSaida: 'Data de Saída',
		TeleControleViagem_lDataRetorno: 'Data de Retorno',
		TeleControleViagem_lPeriodo: 'Periodo',
		TeleControleViagem_lDe: 'DE',
		TeleControleViagem_lPara: 'PARA',
		TeleControleViagem_lRegiaoAtendida: 'Região Atendida',
		TeleControleViagem_lQtdCidades: 'Qtd Cidades',
		TeleControleViagem_lQtdEntregas: 'Qtd Entregas',
		TeleControleViagem_lPeso: 'Peso',
		TeleControleViagem_lValor: 'Valor',
		TeleControleViagem_lValorAdiantamento: 'Adiantamento Custo',
		TeleControleViagem_lDistancia: 'Distância',
		TeleControleViagem_lPolilinha: 'Trajeto',
		TeleControleViagem_BtnControleRota: 'Controlar Percurso ',
		TeleControleViagem_Msg_DeParaObrigatorio: 'Selecione o ínicio (DE) e o destino(PARA) da viagem para habilitar o controle do percurso ',
		TeleControleViagem_lPermitirIniciarAntesPlanejado: 'Permitir iniciar antes',
		TeleControleViagem_lEquipamento: 'Equipamento',
		TeleControleViagem_lStatusAceiteMotoristaa: 'Aceite Motorista',
		TeleControleViagem_lPermitirSomenteComAceite: 'Iniciar somente com aceite',
		TeleControleViagem_lAlterarMotoristaNoVeiculo: 'Alterar motorista ao iniciar',
		TelaZonaRoteirizacao_lCodigo: 'Código',
		TelaZonaRoteirizacao_lNome: 'Nome',
		TelaZonaRoteirizacao_lPesoMinimo: 'Peso Mínimo',
		TelaZonaRoteirizacao_lMinimoPesoVeiculo: '% Mínimo Peso Veículo',
		TelaZonaRoteirizacao_lMaximoPesoVeiculo: '% Máximo Peso Veículo',
		TelaZonaRoteirizacao_lDesconsiderarDeslocamento: 'Desconsiderar deslocamento viagem',
		TelaZonaRoteirizacao_lListaVeiculos: 'Veículos permitidos',
		TelaZonaRoteirizacao_Msg_AreaZona: 'Área da zona incompleta',
		TelaZonaRoteirizacao_btnLimparZona: 'LimparZona',
		TelaZonaRoteirizacao_Msg_VeiculoJaExistente: 'Veículo já associado a zona',
		TelaZonaRoteirizacao_lTextoImportacao: 'Arquivo de zonas para importação',
		TelaZonaRoteirizacao_lImportacaoInstrucao: 'O arquivo CSV deve ter como separador o ; (ponto e virgula) e a sequencia de coluna é CODIGO ;  NOME . A primeira linha do arquivo é considerada como cabeçalho. ',
		TelaLojaRoteirizacao_lCodigo: 'Código',
		TelaLojaRoteirizacao_lNome: 'Nome',
		TelaLojaRoteirizacao_lSenha: 'Senha',
		TelaLojaRoteirizacao_BtnImportar: 'Importar',
		TelaLojaRoteirizacao_lTextoImportacao: 'Arquivo de lojas para importação',
		TelaLojaRoteirizacao_lImportacaoInstrucao: 'O arquivo CSV deve ter como separador o ; (ponto e virgula) e a sequencia de coluna é CODIGO ;  NOME . A primeira linha do arquivo é considerada como cabeçalho. ',
		TelaVendedorRoteirizacao_lCodigo: 'Código',
		TelaVendedorRoteirizacao_lNome: 'Nome',
		TelaVendedorRoteirizacao_lStatus: 'Status',
		TelaVendedorRoteirizacao_lSenhaAcesso: 'Senha',
		TelaVendedorRoteirizacao_lTextoImportacao: 'Arquivo de vendedores para importação',
		TelaVendedorRoteirizacao_lImportacaoInstrucao: 'O arquivo CSV deve ter como separador o ; (ponto e virgula) e a sequencia de coluna é CODIGO ;  NOME . A primeira linha do arquivo é considerada como cabeçalho. ',
		TelaVendedorRoteirizacao_lEhArquivoControl: 'Arquivo do Contro ?',
		TelaVendedorRoteirizacao_BtnImportar: 'Importar',
		TelaTipoOcorrencia_lNome: 'Nome',
		TelaTipoOcorrencia_lErroMotorista: 'Erro do Motorista',
		TelaTipoOcorrencia_lErroConferente: 'Erro do Conferente',
		TelaTipoOcorrencia_lErroVendedor: 'Erro do Vendedor',
		TelaTipoOcorrencia_lPeso: 'Peso',
		TelaTipoOcorrencia_Msg_SelecioneUmaOpcao: 'Selecione pelo menos uma opção de tipo de erro',
		TelaPedido_lSemCelular: 'Sem celular',
		TelaPedido_lNaoRoteirizados: 'Não Roteirizados',
		TelaPedido_lVendedor: 'Vendedor',
		TelaPedido_lLoja: 'Loja',
		TelaPedido_lZona: 'Zona',
		TelaPedido_lStatus: 'Status',
		TelaPedido_lPedido: 'Pedido',
		TelaPedido_lCarregamento : 'Carregamento',
		TelaPedido_lLote: 'Lote',
		TelaPedido_lNumeroPedido: 'Número do Pedido',
		TelaPedido_lNumeroNotaFiscal: 'Número Nota Fiscal',
		TelaPedido_lNumeroCelular: 'Número Celular',
		TelaPedido_lData: 'Data',
		TelaPedido_lCompromissoEntrega: 'Compromisso de Entrega',
		TelaPedido_lRenegociacao: 'Renegocição da Entrega',
		TelaPedido_lQuantidade: 'Quantidade',
		TelaPedido_lValor: 'Valor',
		TelaPedido_lDescricao: 'Descrição',
		TelaPedido_lLiberadoParaSeparacao: 'Liberado para Separação',
		TelaPedido_lLiberadoParaRoteirizacao: 'Liberado para Roteirização',
		TelaPedido_lCliente: 'Cliente',
		TelaPedido_lEndereco: 'Endereço',
		TelaPedido_lRestricao: 'Restrições',
		TelaPedido_lPeso: 'Peso',
		TelaPedido_lVolume: 'Volume',
		TelaPedido_lHorarioAtendimento: 'Horário Disponível para Atendimento',
		TelaPedido_lHorarioAtendimentoInicial: 'Horário Inicial',
		TelaPedido_lHorarioAtendimentoFinal: 'Horário Final',
		TelaPedido_lTempoAtendimento: 'T. Atendimento',
		TelaEsqueciMinhaSenha_lTitulo: 'Esqueci Minha Senha',
		TelaEsqueciMinhaSenha_lSubTitulo: 'Informe o CPF/CNPJ e o email cadastrado',
		TelaEsqueciMinhaSenha_lCPFCNPJ: 'CPF/CNPJ',
		TelaEsqueciMinhaSenha_lEmail: 'E-mail',
		TelaEsqueciMinhaSenha_lRecuperarSenha: 'Recuperar Senha',
		TelaTrocarSenha_lTitulo: 'Alteração de Senha',
		TelaTrocarSenha_lSubTitulo: 'Informe os dados e clique em Gravar Nova Senha',
		TelaTrocarSenha_lCPFCNPJ: 'Informe o CPF/CNPJ',
		TelaTrocarSenha_lSenhaAtual: 'Seha atual',
		TelaTrocarSenha_lNovaSenha: 'Nova Senha',
		TelaTrocarSenha_lConfirmacaoNovaSenha: 'Confirmação nova senha',
		TelaTrocarSenha_BtnGravarNovaSenha: 'Gravar Nova Senha',
		TelaTrocarSenha_Msg_MinimoSenha: 'Senha deve ter pelo menos 5 caracteres',
		TelaTrocarSenha_Msg_ConfirmaSenhaDiferente: 'Confirmação está diferente da nova senha',
		TelaRoteirizacao_lVeiculo: 'Veículo',
		TelaRoteirizacao_lMotorista: 'Motorista',
		TeleRoteirizacao_lPedido: 'Pedido',
		TeleRoteirizacao_lCarregamento: 'Carregamento',
		TelaRoteirizacao_lStatus: 'Status',
		TelaRoteirizacao_lDataInicioPlanejada: 'Data Início',
		TelaRoteirizacao_lDataFimPlanejada: 'Data Fim',
		TelaRoteirizacao_lDataInicioRealizado: 'Data Início',
		TelaRoteirizacao_lDataFimRealizado: 'Data Fim',
		TelaRoteirizacao_lPoISaida: 'Ponto de Saída',
		TelaRoteirizacao_lPoIRetorno: 'Ponto de Retorno',
		TelaRoteirizacao_lDistanciaPrevista: 'Distancia Prevista',
		TelaRoteirizacao_lTempoEstimado: 'Tempo Estimado',
		TelaRoteirizacao_lValorDevolvido: 'Valor Devolvido',
		TelaRoteirizacao_lSincronizacao: 'Sincronização',
		TelaRoteirizacao_Btn_RemoveSincronizacao: 'Remover Sincronização',
		TelaRoteirizacao_Msg_RotaDoRoteirizador: 'Rota criada pelo roteirizador deve ser modificada pelo módulo de roteirização.',
		TelaRoteirizacao_lValor: 'Valor Transportado',
		TelaRoteirizacao_lQtdItinerarios: 'Quantidade de Itinerarios',
		TelaRoteirizacao_lPeso: 'Peso',
		TelaRoteirizacao_lVolume: 'Volume',

		TelaItinerario_lVendedor: 'Vendedor',
		TelaItinerario_lLoja: 'Loja',
		TelaItinerario_lZona: 'Zona',
		TelaItinerario_lStatus: 'Status',
		TelaItinerario_lCarregamento : 'Carregamento',
		TelaItinerario_lVeiculo: 'Veiculo',
		TelaItinerario_lMotorista: 'Motorista',
		TelaItinerario_lNumeroPedido: 'Número do Pedido',
		TelaItinerario_lNumeroNotaFiscal: 'Nota Fiscal',
		TelaItinerario_lDataPedido: 'Data do Pedido',
		TelaItinerario_lDataItinerario: 'Data do Itinerario',
		TelaItinerario_lQuantidade: 'Quantidade',
		TelaItinerario_lValor: 'Valor',
		TelaItinerario_lDescricao: 'Descrição',
		TelaItinerario_lCliente: 'Cliente',
		TelaItinerario_lEndereco: 'Endereço',
		TelaItinerario_lRestricao: 'Restrições',
		TelaItinerario_lPeso: 'Peso',
		TelaItinerario_lVolume: 'Volume',
		TelaItinerario_lHorarioAtendimento: 'Horário Disponível para Atendimento',
		TelaItinerario_lHorarioAtendimentoInicial: 'Horário Inicial',
		TelaItinerario_lHorarioAtendimentoFinal: 'Horário Final',
		TelaItinerario_lTempoAtendimento: 'T. Atendimento',
		TelaItinerario_lDataEntrega : 'Data da Entrega',
		TelaItinerario_lNotaTablet : 'Nota do Aplicativo',
		TelaItinerario_lNotaSMS : 'Nota do SMS',
		TelaItinerario_lTipoOcorrencia : 'Ocorrência',
		TelaRoteirizador_lListaPedidos: 'Lista de Pedidos',
		TelaRoteirizador_lLocalSaida: 'Local de saída',
		TelaRoteirizador_lLocalRetorno: 'Local de retorno',
		TelaRoteirizador_lDataRota: 'Data da Rota',
		TelaRoteirizador_lVeiculo: 'Veículos',
		TelaRoteirizador_lRestricoes: 'Restrições',
		TelaRoteirizador_lRestricoesPeso: 'Peso',
		TelaRoteirizador_lRestricoesVolume: 'Volume',
		TelaRoteirizador_lRestricoesZona: 'Zona',
		TelaRoteirizador_lRestricoesJanelaAtendimento: 'Janela de Atendimento',
		TelaRoteirizador_lRestricoesQtdMaxItens: 'Qtd Máx.Itens',
		TelaRoteirizador_lRestricoesAgruparZona: 'Agrupar Zona',
		TelaRoteirizador_lRestricoesAgruparVendedor: 'Agrupar Vendedor',
		TelaRoteirizador_lJornadaInicio: 'Jornada Início',
		TelaRoteirizador_lIntervaloIncio: 'Intervalo Início',
		TelaRoteirizador_lIntervaloFim: 'Intervalo Fim',
		TelaRoteirizador_lJornadaFim: 'Jornada Fim',
		TeleAlmoxarifadoPneu_lDescricao: 'Descrição',
		TeleFabricantePneu_lNome: 'Nome',
		TelaMotivoSucateamento_lDescricao: 'Descricao',
		TelaDimensaoPneu_lAplicacao: 'Aplicação',
		TelaDimensaoPneu_lLargura: 'Largura',
		TelaDimensaoPneu_lPerfil: 'Perfil',
		TelaDimensaoPneu_lAro: 'Aro',
		TelaDimensaoPneu_lRadial: 'Radial',
		TelaBandaRodagemPneu_lFabricante: 'Fabricante',
		TelaBandaRodagemPneu_lDescricao: 'Descrição',
		TelaBandaRodagemPneu_lTipoDesenho: 'Tipo Desenho',
		TelaModeloPneu_lDescricao: 'Descrição',
		TelaModeloPneu_lFabricante: 'Fabricante',		
		TelaModeloPneu_lDimensao: 'Dimensão',
		TelaModeloPneu_lSulco: 'Sulco',
		TelaModeloPneu_lSulcoMinimo: 'Sulco Mínimo',
		TelaModeloPneu_lPressaoRecomendada: 'Pressão Recomendada',
		TelaModeloPneu_lComCamera: 'Possui Camera',
		TelaModeloPneu_Msg_SulcoMinimoInvalido: 'O Sulco mínimo deve ser menor que o Sulco',
		TelaModeloPneu_lPressaoMinima: 'Pressão Mínima',
		TelaModeloPneu_lPressaoMaxima: 'Pressão Máxima',
		TelaPneu_lNumeroFogo: 'Numero de Fogo',
		TelaPneu_lDOT: 'DOT',
		TelaPneu_lSerie: 'Série',
		TelaPneu_lModelo: 'Modelo',
		TelaPneu_lDataMovimentacao: 'Data da Movimentação',
		TelaPneu_lTipoAquisicao: 'Tipo de Aquisição',
		TelaPneu_lVida: 'Vida',
		TelaPneu_lBandaRodagem : 'Banda de Rodagem',
		TelaPneu_lSulco: 'Sulco Atual',
		TelaPneu_lControladoPor: 'Controlado Por',
		TelaPneu_lKMRodado: 'Km Rodado',
		TelaPneu_lAlmoxarifado: 'Amoxarifado',
		TelaPneu_lFornecedor: 'Fornecedor',
		TelaPneu_lDocumentoNFE: 'Doc./NF-e',
		TelaPneu_lDataEmissaoDocumento: 'Emissão',
		TelaPneu_lValorUnitario: 'Valor',
		TelaPneu_lStatus: 'Status',
		TelaPneu_lVeiculo: 'Veículo',
		TelaInspecaoPneu_lNomeFogo: 'Número de Fogo',
		TelaInspecaoPneu_lFabricante: 'Fabricante',
		TelaInspecaoPneu_lModelo: 'Modelo',
		TelaInspecaoPneu_lData: 'Data',
		TelaInspecaoPneu_lOdometro: "Odômetro (km)",
		TelaInspecaoPneu_lPressao: 'Pressão Aferida',
		TelaInspecaoPneu_lPressaoRecomendada: 'Pressão Recomendada',
		TelaInspecaoPneu_lSulcoAtual_Medida1: 'Sulco Atual - Medida 1',
		TelaInspecaoPneu_lSulcoAtual_Medida2: 'Sulco Atual - Medida 2',
		TelaInspecaoPneu_lSulcoAtual_Medida3: 'Sulco Atual - Medida 3',
		TelaInspecaoPneu_lSulcoMinimo: 'Sulco Mínimo',
		TelaInspecaoPneu_Msg_Instrucao: 'Clique no pneu desejado para informar os dados da inspeção',
		TeleTipoDespesa_lTipo: 'Tipo',
		TelaTipoReceita_lTipo: 'Tipo',
		TeleEquipamentoViagem_lTipo: 'Tipo',
		TeleEquipamentoViagem_lPlaca: 'Placa',
		TeleEquipamentoViagem_lStatus: 'Status',
		TeleEventoMonitriip_lVeiculo: 'Veículo',
		TeleEventoMonitriip_lOperacao: 'Operação',
		TeleEventoMonitriip_lDataHora: 'Data/Hora',
		TeleEventoMonitriip_lIMEI : 'IMEI',
		TeleEventoMonitriip_lLatitude : 'Latitude',
		TeleEventoMonitriip_lLongitude : 'Longitude',
		TeleEventoMonitriip_lCPFMotorista : 'CPF Motorista',
		TeleEventoMonitriip_lTipoEvento : 'Tipo Evento',
		TeleEventoMonitriip_lAutorizacaoViagem : 'Autorização Viagem',
		TeleEventoMonitriip_lTipoRegistroViagem : 'Tipo Registro Viagem',
		TeleEventoMonitriip_lMotivoParada : 'Motivo Parada',
		TeleEventoMonitriip_lTipoRegistroEvento : 'Tipo Registro Evento',
		TeleEventoMonitriip_lSentidoLinha : 'Sentido Linha',
		TeleEventoMonitriip_lIdentificacaoLinha : 'Identificação Linha',
		TeleEventoMonitriip_lCodigoTipoViagem : 'Código Tipo Viagem',
		TeleEventoMonitriip_lDataProgramaViagem : 'Data Programada Viagem',
		TeleEventoMonitriip_lHoraProgramadaViagem : 'Hora Programada Viagem',
		TeleEventoMonitriip_lDataRecebimento : 'Data Recebimento',
		TeleEventoMonitriip_lDataEnvioANTT : 'Data envio ANTT',
		TeleEventoMonitriip_lProcessado : 'Processado',
		TelaTipoItemAgendaEvento_codigo : 'Código',
		TelaTipoItemAgendaEvento_descricao : 'Descrição',
		TelaGrupoDespesa_codigo : 'Código',
		TelaGrupoDespesa_nome : 'Nome',	
		TelaGrupoReceita_codigo : 'Código',
		TelaGrupoReceita_nome : 'Nome',	
		TelaSomAviso_lTipoAviso: 'Tipo do Aviso',
		TelaSomAviso_lNomeArquivoSom: 'Som',
		Menu_ControleEstoque_CategoriaProduto: 'Categorias de Peças',
		TelaControleEstoque_CategoriaProduto_lNome: 'Nome',
		TelaControleEstoque_CategoriaProduto_lDescricao: 'Descrição',
		Menu_ControleEstoque_Deposito: 'Depósitos de Peças',		
		TelaControleEstoque_Deposito_lNome: 'Nome',
		TelaControleEstoque_Deposito_lDesconsiderarSaldo: 'Desconsiderar Saldo',
		Menu_ControleEstoque_Produto: 'Peças',
		TelaControleEstoque_Produto_lCategoria: 'Categoria',
		TelaControleEstoque_Produto_lCodigo: 'Código',
		TelaControleEstoque_Produto_lNome: 'Nome',
		TelaControleEstoque_Produto_lDescricao: 'Descrição',
		TelaControleEstoque_Produto_lEstoqueMinimo: 'Estoque Mínimo',
		TelaControleEstoque_Produto_lEstoqueMaximo: 'Estoque Máximo',
		TelaControleEstoque_Produto_lSaldoAtual: 'Estoque Atual',
		TelaControleEstoque_Produto_lUnidadeDeMedida: 'Unidade de Medida',
		TelaControleEstoque_Produto_lDataHoraUltimaAtualizacao: 'Ultima Atualização',
		TelaControleEstoque_Produto_lStatus: 'Status',
		Menu_ControleEstoque_ComprasProduto: 'Compras de Peças',
		TelaControleEstoque_ComprasProduto_lFornecedor: 'Fornecedor',
		TelaControleEstoque_ComprasProduto_lDeposito: 'Depósito',
		TelaControleEstoque_ComprasProduto_lData: 'Data',
		TelaControleEstoque_ComprasProduto_lNotaFiscal: 'Nota Fiscal',
		TelaControleEstoque_ComprasProduto_lObservacao: 'Observação',
		TelaControleEstoque_ComprasProduto_lValor: 'Valor',
		TelaControleEstoque_ComprasProduto_lProduto: 'Peça',
		TelaControleEstoque_ComprasProduto_lQtd: 'Quantidade',
		TelaControleEstoque_ComprasProduto_lValorUnitario: 'Valor Unitário',
		Menu_ControleEstoque_MovimentacaoEstoque: 'Movimentação de Estoque',
		TelaControleEstoque_MovimentacaoEstoque_lTipoMovimentacao: 'Tipo Movimentação',
		TelaControleEstoque_MovimentacaoEstoque_lData: 'Data',
		TelaControleEstoque_MovimentacaoEstoque_lDepositoOrigem: 'Depósito Origem',
		TelaControleEstoque_MovimentacaoEstoque_lDepositoDestino: 'Depósito Destino',
		TelaControleEstoque_MovimentacaoEstoque_lObservacao: 'Observação',
		TelaControleEstoque_MovimentacaoEstoque_lVeiculoOrigem: 'Veículo Origem',
		TelaControleEstoque_MovimentacaoEstoque_lVeiculoDestino: 'Veículo Destino',
		Menu_ControleEstoque_EstoqueEmVeiculos: 'Peças em Veículos',
		TelaControleEstoque_EstoqueEmVeiculos_lPlaca: 'Placa do Veículo',
		TelaTipoOcorrenciasVeiculo_lNome: 'Nome',
		TelaTipoOcorrenciasVeiculo_lAtivo: 'Ativo',
		TelaOcorrenciasVeiculo_lVeiculo: 'Veiculo',
		TelaOcorrenciasVeiculo_lMotorista: 'Motorista',
		TelaOcorrenciasVeiculo_lTipoOcorrencia: 'Tipo da Ocorrência',
		TelaOcorrenciasVeiculo_lDataHora: 'Data/Hora',
		TelaOcorrenciasVeiculo_lDescricao: 'Descrição',
		TelaOcorrenciasVeiculo_lStatus: 'Status',
		TelaOcorrenciasVeiculo_lDataHoraCadastro: 'Data/Hora do Cadastro',
		TelaModeloCheckList_codigo : 'Nome',
		TelaModeloCheckList_descricao : 'Descrição',
		TelaModeloCheckList_ativo : 'Ativo',
		TelaModeloCheckList_dataCriacao : 'Criado',
		TelaModeloCheckList_dataAlteracao : 'Alterado',
		TelaItemModeloCheckList_nome : 'Titulo',
		TelaItemModeloCheckList_descricao : 'Descrição',
		TelaItemModeloCheckList_obrigatorio : 'Obrigatório',
		TelaItemModeloCheckList_exigirFotoSeReprovado : 'Exigir Foto',
		TelaItemModeloCheckList_exigirObservacaoSeReprovado : 'Exigir Observação',
		TelaItemModeloCheckList_abrirOcorrenciaSeReprovado : 'Abrir Ocorrência',
		TelaItemModeloCheckList_exigirFotoSeAprovado : 'Exigir Foto',
		TelaItemModeloCheckList_exigirObservacaoSeAprovado : 'Exigir Observação',
		TelaItemModeloCheckList_abrirOcorrenciaSeAprovado : 'Abrir Ocorrência',
		TelaItemModeloCheckList_seReprovado : 'Se Reprovado',
		TelaItemModeloCheckList_seAprovado : 'Se Aprovado',
		TelaVeiculoExterno_marca: 'Marca',
		TelaVeiculoExterno_modelo: 'Modelo',
		TelaVeiculoExterno_placa: 'Placa',
		TelaVeiculoExterno_cor: 'Cor',
		TelaVeiculoExterno_nomeMotorista: 'Nome Motorista',
		TelaVeiculoExterno_ativo: 'Ativo',
		TelaVeiculoExterno_dataHoraCadastro: 'Data/Hora Cadastro',
		TelaVeiculoExterno_usuario: 'Usuário',
		TelaPerfilCoresVelocidadePercurso_nome: 'Nome',
		TelaPerfilCoresVelocidadePercurso_velocidadeFaixa1: ' Velocidade Faixa 1',
		TelaPerfilCoresVelocidadePercurso_velocidadeFaixa2: ' Velocidade Faixa 2',
		TelaPerfilCoresVelocidadePercurso_velocidadeFaixa3: ' Velocidade Faixa 3',
		TelaPerfilCoresVelocidadePercurso_velocidadeFaixa1Inicio: ' Velocidade Inicio Faixa 1',
		TelaPerfilCoresVelocidadePercurso_velocidadeFaixa2Inicio: ' Velocidade Inicio Faixa 2',
		TelaPerfilCoresVelocidadePercurso_velocidadeFaixa3Inicio: ' Velocidade Inicio Faixa 3',
		TelaPerfilCoresVelocidadePercurso_velocidadeFaixa1Fim: ' Velocidade Fim Faixa 1',
		TelaPerfilCoresVelocidadePercurso_velocidadeFaixa2Fim: ' Velocidade Fim Faixa 2',
		TelaPerfilCoresVelocidadePercurso_velocidadeFaixa3Fim: ' Velocidade Fim Faixa 3',
		Mensagem_Erro_Intersecao_Faixa1_Faixa2: "The end speed of Range 1 cannot be greater than or equal to the start speed of Range 2.",
		Mensagem_Erro_Intersecao_Faixa2_Faixa3: "The end speed of Range 2 cannot be greater than or equal to the start speed of Range 3.",
		Mensagem_Erro_Ordem_Faixa1: "The start speed of Range 1 must be less than the end speed.",
		Mensagem_Erro_Ordem_Faixa2: "The start speed of Range 2 must be less than the end speed.",
		Mensagem_Erro_Ordem_Faixa3: "The start speed of Range 3 must be less than the end speed."
	},
	es: {
		Ativo: 'Activo',
		PoliticaPrivacidade: 'Política de Privacidade',
		SelecionarTodos: 'Select All',
		DesselecionarTodos: 'Unselect All',
		Dashboard: 'Dashboard',
		DashboardVeiculos: 'Fleet Dashboard',
		DashboardMotoristas: 'Driver Dashboard',
		DashboardTelemetria: 'Telemetry Dashboard',
		DashboardCameras: 'Cameras Dashboard',
		DashboardDespesas: 'Expenses Dashboard',
		Periodo: 'Período',
		Sim: 'Yes',
		Nao: 'No',
		Dia_Semana_Seg: 'Segunda',
		Dia_Semana_Ter: 'Terça',
		Dia_Semana_Qua: 'Quarta',
		Dia_Semana_Qui: 'Quinta',
		Dia_Semana_Sex: 'Sexta',
		Dia_Semana_Sab: 'Sabado',
		Dia_Semana_Dom: 'Domingo',
		Atencao: 'Attention',
		Erro: 'Error',
		Mapa: 'Map',
		Grid: 'Grid',
		Percursos: 'Ruta',
		Avisos: 'Avisos',
		Tipo_Aviso: 'Alert Type',
		Frotas: 'Frotas',
		Viagens: 'Viajes',
		Pneus: 'Neumáticos',
		Roteirizacao: 'Enrutamiento',
		Relatorios: 'Informes',
		Configuracao: 'Configuración',
		Bloqueio: 'Cerradura',
		Veiculo: 'Car',
		Veiculos: 'Cars',
		Placa: 'Placa',
		Motorista: 'Chofer',		
		KmhParado: 'Km/h - Detenido',
		Sensor: 'Sensor',
		Location: 'Ubicación',
		Parado: 'Detenido',		
		Desatualizado: 'Anticuado',
		AlertaParado: 'Alerta detenida',
		ComSensor: 'With Sensor',		
		Acesso: 'Identificación',		
		MensagemAcesso: 'Welcome back, please login to your account.',
		TelaLogin_phCPFCNPJ: 'Ingrese el CPF o CNPJ o login',
		TelaLogin_lLembrarSenha: 'Recuérdame',
		TelaLogin_lEsqueciSenha: 'Olvide mi contraseña',
		TelaLogin_lEntrar: 'Entrar',		
		TelaLogin_lTrocarSenha: 'Cambiar Contraseña',		
		Mensagem_LoginInvalido: 'El login y / o contraseña ingresados ​​no son válidos.',
		Mensagem_Login_Bloqueado: '',
		NenhumVeiculoEncontrado: '',
		NenhumEquipamentoEncontrado: 'Nenhum equipamento encontrado',
		NenhumMotoristaEncontrado: 'Nenhum motorista encontrado',
		Tooltipo_Exibir_Cidade: 'Exibir o nome da cidade',
		Tooltipo_Exibir_Endereco: 'Exibir o endereço completo',
		Tooltip_Qtd_Veiculos: 'Quantidade de veículos rastreados',
		Tooltip_Filtro_Parados: 'Exibir somente os veículos parados',
		Tooltip_Filtro_Desatualizados: 'Exibir somente os veículos desatualizados',
		Tooltip_Filtro_AlertaParados: 'Exibir somente os veículos com alerta de tempo parado',
		Tooltip_Filtro_ComSensor: 'Exibir somente os veículos com sensor',
		Tooltip_Filtro_ComControleViagem: 'Exibir somente os veículos que estão em Viagem Iniciada',
		Aviso: 'Alert',		
		Descricao: 'Description',
		Hora: 'Time',
		AvisosDoDia: 'Avisos do Dia',
		Tooltip_Qtd_Avisos: 'Quantidade de avisos',
		Mensagem_Ver_Todos_Avisos_Dia: 'Ver todos os avisos do dia',
		Cidade: 'Ciudad',
		PopUp_AgruparPorCidade: 'Veículos por cidade',
		Pesquisa: 'Search',
		LimparFiltros: 'Clean filters',
		ExportarParaCSV: 'Exportar para CSV',
		Novo: 'Novo',
		Filtros: 'Filtros',
		Qtd: 'Qtd',
		Divisao: 'Divison',
		Divisao_Veiculo: 'Divisão de Veículos',
		Divisao_Motorista: 'Drivers Divison',
		Imprimir: 'Imprimir',
		Agrupar: 'Agrupar',
		Fechar: 'Fechar',
		PontosInteresse: 'Pontos de Interesse',
		AgGrid_Contains: 'Contains',
		AgGrid_notContains: 'Not Contains',
        AgGrid_startsWith: 'Starts with',
        AgGrid_endsWith: 'Ends with',
        AgGrid_andCondition: 'AND',
        AgGrid_orCondition: 'OR',
        AgGrid_filters: 'Filters',
        AgGrid_equals: 'Equals',
		AgGrid_notEqual: 'NotEqual',
		AgGrid_filterOoo: 'Filtrar ...',
		Exibidos: 'Exibido(s)',
		Gravar_Exibidos:'Gravar exibidos',
		Perimetros: 'Perímetros',
		Btn_Gravar: 'Save',
		Btn_Limpar: 'Limpar',
		Btn_Voltar: 'Voltar',
		Btn_Excluir: 'Excluir',
		Btn_Localizar_Endereco: 'Localiza Endereço',
		Btn_Fechar: 'Fechar',
		Btn_OK: 'OK',
		Btn_CentralizarPerimetro: 'Centralizar Perímetro',
		Btn_Importar_KML: 'Importar KML',
		Btn_Ativar: 'Ativar',
		Btn_Desativar: 'Desativar',
		Btn_Bloquear: 'Ativar',
		Btn_Desbloquear: 'Desativar',
		Btn_Inserir: 'Inserir',
		Btn_InserirLimpar: 'Inserir e Limpar',
		Btn_Importar: 'Importar',
		Cor_Localidade: 'Cor Localidade',
		Titulo_Corrigir_Erros: 'Please correct the following error(s):',
		Mensagem_Erro_Obrigatorio: 'required',
		Mensagem_Erro_Invalido: 'invalid',
		TelaMotorista_lNome: 'Nome',
		TelaMotorista_lMatricula: 'Matricula',
		TelaMotorista_lCPF: 'CPF',
		TelaMotorista_lRG: 'RG',
		TelaMotorista_lCNH: 'CNH',
		TelaMotorista_lCategoriaCNH: 'Categoria',
		TelaMotorista_lValidadeCNH: 'Validade CNH',
		TelaMotorista_lValidadeExameToxicologico: 'Validade Exame Toxicológico',
		TelaMotorista_lValidadeMOPP: 'Validade MOPP',
		TelaMotorista_lChaveiroCartao: 'Chaveiro/Cartão',
		TelaMotorista_lDataHoraInicioUsoCartao: 'Data/Hora Início do uso do chaveiro/cartão',
		TelaMotorista_lSenha: 'Senha',
		TelaMotorista_lEnderecos: 'Endereços',
		TelaMotorista_lTelefones: 'Telefones',
		TelaMotorista_lAtivo: 'Ativo',
		TelaMotorista_Mensagem_Erro_1: 'Informe a data e a hora de início de uso do chaveiro com este motorista',
		TelaMotorista_lImportacaoInstrucao: 'O arquivo CSV deve ter como separador o ; (ponto e virgula) e a sequencia de coluna é NOME ;  MATRICULA ; CPF ; RG ; CNH ; CATEGORIA ; VALIDADE CNH (formato dd/MM/yyyy) ; ENDERECO; TELEFONES ; CODIGO CHAVEIRO ; DATA ATIVACAO (formato dd/MM/yyyy HH:mm:ss) ;',
		TelaMotorista_lImportacaoInstrucao2: 'A primeira linha do arquivo é considerada como cabeçalho.',
		TelaMotorista_lImportacaoInstrucao3: 'Os motoristas serão atualizados caso tenha codigo do chaveiro, a matricula, cpf ou nome já cadastrado previamente. Para cadastrar o motorista com chaveiro a data de ativação do chaveiro é obrigatória. Se informado apenas o código do chaveiro, a plataforma apenas tentará atualizar.',
		TelaCorLocalidade_lNome: 'Nome da Localidade',	
		TelaDivisao_lCodigo: 'Codigo',
		TelaDivisao_lNome: 'Nome',
		TelaCategoriaAviso_lNome: 'Nome',
		TelaCategoriaAviso_lTipo: 'Tipo',	
		TelaPontuacaoAviso_lTipoAviso: 'Tipo do Aviso',
		TelaPontuacaoAviso_lTipoCategoria: 'Categoria do Aviso',
		TelaPontuacaoAviso_lPontuacao: 'Pontuação',	
		Menu_Alterar_Veiculo: 'Alteração Veículo',
		Menu_Alterar_Dados_Contato_Veiculo: 'Alteração Dados Contato',
		TelaAlterarVeiculo_lCategoria: 'Categoria',
		TelaAlterarVeiculo_lDivisao: 'Divisão',
		TelaAlterarVeiculo_lTipoVeiculo: 'Tipo Veículo',
		TelaAlterarVeiculo_lMarca: 'Marca',
		TelaAlterarVeiculo_lModelo: 'Modelo',
		TelaAlterarVeiculo_lModeloOutro: 'Outro Modelo',
		TelaAlterarVeiculo_lPlaca: 'Placa',
		TelaAlterarVeiculo_lMesVencto: 'Mês Vencto',
		TelaAlterarVeiculo_lLabel: 'Label',
		TelaAlterarVeiculo_lAnoFabricacao: 'Ano Fabricação',
		TelaAlterarVeiculo_lAnoModelo: 'Ano Modelo',
		TelaAlterarVeiculo_lCor: 'Cor',
		TelaAlterarVeiculo_lChassi: 'Chassi', 
		TelaAlterarVeiculo_lRenavam: 'Renavam',  	
		TelaAlterarVeiculo_lCondutor: 'Condutor', 
		TelaAlterarVeiculo_lKMl: 'KM/l', 
		TelaAlterarVeiculo_lLh: 'L/h', 
		TelaAlterarVeiculo_lHorimetro: 'Horímetro', 
		TelaAlterarVeiculo_lOdometro: 'Odômetro', 		
		TelaAlterarVeiculo_lSenhaAcessoIndividual: 'Senha de Acesso Individual', 
		TelaAlterarVeiculo_lVelocidadeMinima: 'Velocidade Mínima km/h', 
		TelaAlterarVeiculo_lVelocidadeMaxima: 'Velocidade Máxima km/h', 		
		TelaAlterarVeiculo_lLabelControleHorario: 'Controlar horários de uso dos veículos',
		TelaAlterarVeiculo_lMensagemControleHorario: 'Informe os horários permitidos de utilização do veículo',
		TelaAlterarVeiculo_lAvisarExcessoVelocidade: 'Avisar Excesso Velocidade',
		TelaAlterarVeiculo_lAvisarExcessoVelocidadeVia: 'Avisar Excesso Velocidade na Cidade',
		TelaAlterarVeiculo_lVeiculoEmManutencao: 'Veículo em manutenção',
		TelaAlterarVeiculo_lAvisarSaidaPerimetro: 'Avisar Saída Perímetro',
		TelaAlterarVeiculo_lAvisarVeiculoParado: 'Avisar Veículo Parado',
		TelaAlterarVeiculo_lTempoParada: "Tempo parada em minutos",
		TelaAlterarVeiculo_lLimitePressaoAcelerador: "Limite Pressão Acelerador",
		TelaAlterarVeiculo_lSelecionarPerimetro: "Selecione o perímetro",
		TelaAlterarVeiculo_lRPMMax: "RPM Máximo",
		TelaAlterarVeiculo_lTempoDirecaoMaximo: "Tempo Máximo de Direção",
		TelaAlterarVeiculo_lLigarAncoragem: "Ligar Ancoragem",
		TelaAlterarVeiculo_lAvisarVeiculoLigado: "Avisar Veículo Ligado",
		TelaAlterarVeiculo_lAvisarVeiculoDesligado: "Avisar Veículo Desligado",
		TelaAlterarVeiculo_lAvisarVeiculoParadoLigado: "Avisar Veículo Parado Ligado?",
		TelaAlterarVeiculo_lResponsavel1: "Responsável 1",
		TelaAlterarVeiculo_lResponsavel2: "Responsável 2",
		TelaAlterarVeiculo_lEmail1: "Email 1",
		TelaAlterarVeiculo_lEmail2: "Email 2",
		TelaAlterarVeiculo_lCelular1: "Celular 1",
		TelaAlterarVeiculo_lCelular2: "Celular 2",
		TelaAlterarVeiculo_lContatoEmergencia: "Contatos de Emergência",
		TelaAlterarVeiculo_lHoraGeracao: "Hora Geração",
		TelaAlterarVeiculo_lAnexarMapa: "Anexar Mapa ?",
		TelaAlterarVeiculo_lEnviarFinalSemana: "Enviar final de semana ?",
		TelaAlterarVeiculo_lTempoMinimoParada: "Tempo Mínimo ( minutos)",
		TelaAlterarVeiculo_lSoParadaLigado: "Só paradas ligado ?",
		TelaAlterarVeiculo_lSoEmPontosInteresse: "Só em pontos de interesse ?",
		TelaAlterarVeiculo_MensagemRota: 'Parâmetros utilizados na roteirização e aplicativo Minha Rota',
		TelaAlterarVeiculo_lSenhaAplicativoEntrega: 'Senha aplicativo de entrega',
		TelaAlterarVeiculo_lCapacidadePeso: 'Capacidade - Peso',
		TelaAlterarVeiculo_lCapacidadeVolume: 'Capacidade - Volume',
		TelaAlterarVeiculo_lCustoPorKM: 'Custo por KM',
		TelaAlterarVeiculo_lQtdMaximaItinerarios: 'Quantidade máxima de itinerários',
		TelaAlterarVeiculo_lLabelHorarioBloqueio: 'Bloqueio automático do veículo',
		TelaAlterarVeiculo_lMensagemHorarioBloqueio: 'Informe os horários que o veículo deve ser bloqueado e desbloqueado',
		TelaAlterarVeiculo_lMensagemVeiculoSemBloqueio: 'Este veículo não possui o acessório de bloqueio instalado.',
		TelaAlterarVeiculo_Btn_RepetirSegunda: 'Repetir Horário de Segunda',
		TelaAlterarVeiculo_Btn_RepetirSegundaAteSexta: 'Repetir Horário de Segunda até Sexta',
		TelaAlterarVeiculo_lCapacidadeTanque: 'Capacidade tanque ( litros )',
		TelaAlterarVeiculo_lAcessosDisponveis: 'ACESSOS DISPONÍVEIS',
		TelaAlterarVeiculo_lAcessosSelecionados: 'ACESSOS SELECIONADOS',
		TelaAlterarVeiculo_lTiposCombustiveisDisponiveis: 'TIPOS DE COMBUSTÍVEIS DISPONÍVEIS',
		TelaAlterarVeiculo_lTiposCombustiveisDoVeiculo: 'TIPOS DE COMBUSTÍVEIS DO VEÍCULO',
		TelaAlterarVeiculo_lMensagemFaixasRPM: 'Configure as faixas de RPM do veículo',
		TelaAlterarVeiculo_lFaixa1RPM: 'Faixa 1',
		TelaAlterarVeiculo_lFaixa2RPM: 'Faixa 2',
		TelaAlterarVeiculo_lFaixa3RPM: 'Faixa 3',
		TelaAlterarVeiculo_lFaixa4RPM: 'Faixa 4',
		TelaAlterarVeiculo_lFaixa5RPM: 'Faixa 5',
		TelaAlterarVeiculo_lAcimaFaixa5RPM: 'Acima da Faixa 5',
		TelaAlterarVeiculo_lAtualizacaoRPMPorMinuto: 'Atualizações por minuto',
		TelaAlterarVeiculo_Msg1_PopupMotoristas: 'Selecione o novo motorista para o veículo.',
		TelaAlterarVeiculo_Msg2_PopupMotoristas: 'Clique nos motoristas que são autorizados a utilizar o veículo.',
		TelaAlterarVeiculo_Mensagem_Erro_1: 'Acesso já cadastrado',
		TelaAlterarVeiculo_Mensagem_Erro_2: 'Tipo de combustível já selecionado',
		TelaAlterarVeiculo_Mensagem_Erro_3: 'Email 1 de envio do relatório de paradas',
		TelaAlterarVeiculo_Mensagem_Erro_4: 'Hora de envio do relatório de paradas',
		TelaAlterarVeiculo_Mensagem_Erro_5: 'Informe pelo menos um email para o envio do do relatório de paradas',
		TelaAlterarVeiculo_Mensagem_Erro_6: 'Email 2 de envio do relatório de paradas',
		TelaAlterarVeiculo_Mensagem_Erro_7: 'Email 1 de avisos',
		TelaAlterarVeiculo_Mensagem_Erro_8: 'Email 2 de avisos',
		TelaAlterarVeiculo_Mensagem_Erro_9: 'Informe o horário permitido para pelo menos um dia.',
		TelaAlterarVeiculo_Mensagem_Erro_10: 'Horário inválido de Segunda.',
		TelaAlterarVeiculo_Mensagem_Erro_11: 'Horário inválido de Terça.',
		TelaAlterarVeiculo_Mensagem_Erro_12: 'Horário inválido de Quarta.',
		TelaAlterarVeiculo_Mensagem_Erro_13: 'Horário inválido de Quinta.',
		TelaAlterarVeiculo_Mensagem_Erro_14: 'Horário inválido de Sexta.',
		TelaAlterarVeiculo_Mensagem_Erro_15: 'Horário inválido de Sábado.',
		TelaAlterarVeiculo_Mensagem_Erro_16: 'Horário inválido de Domingo.',
		TelaAlterarVeiculo_Mensagem_Erro_17: 'Informe o horário de bloqueio para pelo menos um dia.',
		TelaAlterarVeiculo_Mensagem_Erro_18: 'Horário de bloqueio inválido de Segunda.',
		TelaAlterarVeiculo_Mensagem_Erro_19: 'Horário de bloqueio inválido de Terça.',
		TelaAlterarVeiculo_Mensagem_Erro_20: 'Horário de bloqueio inválido de Quarta.',
		TelaAlterarVeiculo_Mensagem_Erro_21: 'Horário de bloqueio inválido de Quinta.',
		TelaAlterarVeiculo_Mensagem_Erro_22: 'Horário de bloqueio inválido de Sexta.',
		TelaAlterarVeiculo_Mensagem_Erro_23: 'Horário de bloqueio inválido de Sábado.',
		TelaAlterarVeiculo_Mensagem_Erro_24: 'Horário de bloqueio inválido de Domingo.',
		TelaAlterarVeiculo_Mensagem_Erro_25: 'Valor inválido para o mês de vencimento da placa. Digite um numero entre 1 e 12.',
		TelaAlterarVeiculo_Mensagem_Erro_26: 'Valor inválido para o ano de fabricação. Digite um valor acima de 1900.',
		TelaAlterarVeiculo_Mensagem_Erro_27: 'Valor inválido para o ano do modelo. Digite um valor acima de 1900.',
		TelaAlterarVeiculo_Mensagem_Erro_28: 'O Tempo Máximo de Direção deve ser de pelo menos 60 minutos.',	
		TelaAlterarVeiculo_Mensagem_Erro_29: 'O início da faixa {p1} precisa ter o valor menor que o fim da faixa {p2}',
		TelaAlterarVeiculo_Mensagem_Erro_30: 'A faixa {p1} não pode ter interseção de valores com a faixa {p2}',
		TelaAlterarVeiculo_Mensagem_Erro_31: 'Informe o perímetro',
		TelaAlterarVeiculo_Mensagem_Erro_32: 'Informe a velocidade mínima para considerar transito em horário não permitido',
		TelaAlterarVeiculo_MensagemRelatorioDiario: 'Preencha os dados dessa aba se você deseja receber um relatório diário com as paradas do dia anterior deste veículo.',
		TelaPerimetro_lNome: 'Nome',	
		TelaPerimetro_lPerimetro: 'Perímetro',	
		TelaPerimetro_Mensagem: 'Informe o endereço para pesquisar',	
		TelaPerimetro_Mensagem_Erro_1: 'O perímetro deve conter pelo menos 3 pontos no mapa',	
		Menu_Perimetro: 'Perímetros',
		Mensagem_EnderecoNaoEncontrado: 'Endereço não encontrado',
		Menu_Atuadores: 'Atuadores',
		TelaAtuadores_Mensagem_AtivarSaida2: 'Selecione o veículo para ativar a saída 2',
		TelaAtuadores_Mensagem_AtivarSaida3: 'Selecione o veículo para ativar a saída 3',
		TelaAtuadores_lSaida2: 'Saída 2',
		TelaAtuadores_lSaida3: 'Saída 3',
		TelaBloqueio_Mensagem_BloquearDesbloquear: 'Selecione o veículo para bloquear/desbloquear',
		TelaBloqueio_lSenha: 'Informe a senha',
		TelaRelatorio_lPeriodoViagem: 'Período da Viagem',
		TelaRelatorio_lTipoDespesa: 'Tipo de Despesa',
		TelaRelatorio_lTipoReceita: 'Tipo de Receita',
		TelaRelatorio_lFornecedor: 'Fornecedor',
		TelaRelatorio_lCliente: 'Cliente',
		TelaRelatorio_lColunasDisponiveis: 'Colunas Disponíveis',
		TelaRelatorio_lColunasSelecionadas: 'Colunas Selecionadas',
		TelaRelatorio_lGrupoDespesa: 'Grupo Despesa',
		TelaRelatorio_lGrupoReceita: 'Grupo Receita',
		TelaRelatorio_lCategoriaPontoInteresse: 'Grupo Ponto de Interesse',
		TelaPessoasRIFD_lMatricula: 'Matrícula',
		TelaPessoasRIFD_lNome: 'Nome',
		TelaPessoasRIFD_lCodigoChaveiro: 'Codigo Chaveiro/Cartão',
		TelaPessoasRIFD_lStatus: 'Status',
		TelaPessoasRIFD_lSetor: 'Setor',
		TelaAlterarVeiculoLote_lVeiculosDisponiveis: 'Veículos Disponíveis',
		TelaAlterarVeiculoLote_lVeiculosSelecionados: 'Veículos Selecionados',
		TelaAlterarVeiculoLote_Mensagem_Erro_1: 'Selecione pelo menos um veículo.',
		TelaCategoriaveiculo_lMenu: 'Categorias Veículos',
		TelaCategoriaveiculo_lDescricao: 'Descrição',
		TelaCategoriaveiculo_lControladoPor: 'Controlado Por',
		TelaCategoriaveiculo_lAroPneus: 'Aro Pneus',
		TelaCategoriaveiculo_lNumeroEstepes: 'Quantidade Estepes',
		TelaCategoriaveiculo_lEixos: 'Eixos',
		TelaCategoriaveiculo_lMensagem_Erro1: "Informe pelo menos 2 eixos",
		TelaCategoriaveiculo_lMensagem_Erro2p1: "O eixo ",
		TelaCategoriaveiculo_lMensagem_Erro2p2: " precisa ter pelo menos dois pneus selecionados.",
		TelaAgendaEventos_lTipo: 'Tipo',
		TelaAgendaEventos_lVeiculo: 'Veículo',
		TelaAgendaEventos_lNome: 'Nome',
		TelaAgendaEventos_lDescricao: 'Descrição',
		TelaAgendaEventos_lStatus: 'Status',
		TelaAgendaEventos_lEmail: 'E-mail',
		TelaAgendaEventos_lParametros: 'Parâmetros',
		TelaAgendaEventos_lDataEvento: 'Data do Evento',
		TelaAgendaEventos_lKM: 'KM',
		TelaAgendaEventos_lHorimetro: 'Horímetro',
		TelaAgendaEventos_lEnvioEmail: 'E-mail enviado às',
		TelaAgendaEventos_lHoraCadastro: 'Cadastrado às',
		TelaAgendaEventos_lTipoItemAgendaEvento: 'Tipo Item Evento',
		Menu_AgendaEventos: 'Agenda de Eventos',
		Menu_Despesas: 'Despesas',
		Menu_Receitas: 'Receitas',
		Menu_TipoDespesas: 'Tipo Despesas',
		Menu_TipoReceitas: 'Tipo Receitas',
		Menu_Fornecedores: 'Fornecedores',
		Menu_CateogoriaPontoInteresse: 'Grupo Ponto de Interesse',
		Menu_PontoInteresse: 'Ponto de Interesse',
		Menu_ImportarPontoInteresse: 'Importar Pontos de Interesse',
		Menu_TanquesCombustivel: 'Tanques de Combustível',
		Menu_CompraCombustivel: 'Compras de Combustível',
		Menu_MovimentacaoCombustivel: 'Movimentações de Combustível',
		Menu_Tipo_Item_Agenda_Eventos: 'Tipo Item Eventos',
		Menu_Tipo_Ocorrencia_Veiculos: 'Tipo Ocorrência de Veículos',
		Menu_Ocorrencia_Veiculos: 'Ocorrência de Veículos',
		TelaFornecedores_lNome: 'Nome',
		TelaFornecedores_lRazaoSocial: 'Razão Social',
		TelaFornecedores_lCPFCNPJ: 'CPF/CNPJ',
		TelaFornecedores_lEndereco: 'Endereço',
		TelaFornecedores_lTelefone: 'Telefone',
		TelaFornecedores_lEmail: 'E-mail',
		TelaFornecedores_lIsCliente: 'Cliente',
		TelaFornecedores_lIsFornecedor: 'Fornecedor',
		TelaFornecedores_lTextoImportacao: 'Importação de favorecidos por arquivo',
		TelaFornecedores_lImportacaoInstrucao: 'O arquivo CSV deve ter como separador o ; (ponto e virgula) e a sequencia de coluna é NOME ; CNPJ OU CPF; ENDEREÇO ; TELEFONE ; EMAIL ; SE CLIENTE ; SE FORNECEDOR . A primeira linha do arquivo é considerada como cabeçalho. Para as colunas SE CLIENTE ou SE FORNECEDOR, utilizar a letra S para SIM e N para não. ',
		TelaCategoriaPontoInteress_lNome: 'Nome',
		TelaCategoriaPontoInteress_lDescricao: 'Descrição',
		TelaCategoriaPontoInteress_lIcone: 'Icone',
		TelaReceitas_lVeiculo: 'Veículo',
		TelaReceitas_lTipo: 'Tipo',
		TelaReceitas_lRota: 'Rota',
		TelaReceitas_lCliente: 'Cliente',
		TelaReceitas_lNome: 'Nome',
		TelaReceitas_lDescricao: 'Descrição',
		TelaReceitas_lData: 'Data',
		TelaReceitas_lValor: 'Valor',
		TelaReceitas_lQuantidade: 'Quantidade',
		TelaReceitas_lMotorista: 'Motorista',
		TelaReceitas_Msg1_PopupMotoristas: 'Selecione o motorista',
		TelaReceitas_Msg1_PopupRotas: 'Selecione a rota',
		PopUpRotas_lPedido: 'Pedido',
		TelaDespesas_lVeiculo: 'Veículo',
		TelaDespesas_lTipo: 'Tipo',
		TelaDespesas_lRota: 'Rota',
		TelaDespesas_lIdentificador: 'Identificador',
		TelaDespesas_lViagem: 'Viagem',
		TelaDespesas_lFornecedor: 'Fornecedor',
		TelaDespesas_lGrupo: 'Grupo',
		TelaDespesas_lNome: 'Nome',
		TelaDespesas_lDescricao: 'Descrição',
		TelaDespesas_lData: 'Data',
		TelaDespesas_lDataPagamento: 'Data Pagamento',
		TelaDespesas_lPeriodo: 'Período',
		TelaDespesas_lValor: 'Valor',
		TelaDespesas_lQuantidade: 'Quantidade',
		TelaDespesas_lMotorista: 'Motorista',
		TelaDespesas_lTipoCombustivel: 'Tipo Combustível',
		TelaDespesas_lTanqueCombustivel: 'Tanque Combustível',
		TelaDespesas_lOdometro: 'Odômetro',
		TelaDespesas_lHorimetro: 'Horímetro',
		TelaDespesas_lNotaFiscal: 'Nota Fiscal',
		TelaDespesas_Msg1_PopupMotoristas: 'Selecione o motorista',
		TelaDespesas_Msg1_PopupRotas: 'Selecione a rota',
		TelaTanqueCombustivel_lNumero: 'Número',
		TelaTanqueCombustivel_lTipoCombustivel: 'Tipo Combustível',
		TelaTanqueCombustivel_lLocalizacao: 'Localização',
		TelaTanqueCombustivel_lCapacidade: 'Capacidade',
		TelaTanqueCombustivel_lEstoqueAtual: 'Estoque Atual',
		TelaTanqueCombustivel_lEstoqueMinimo: 'Estoque Mínimo',
		TelaTanqueCombustivel_lPrecoMedio: 'Preço Médio',
		TelaTanqueCombustivel_lDescricao: 'Descrição',
		TelaTanqueCombustivel_lCodigoSistemaTerceiro: 'Código do Sistema de Terceiro',
		TelaCompraCombustivel_lNotaFiscal: 'Nota Fiscal',
		TelaCompraCombustivel_lNumeroTanqueCombustivel: 'Número Tanque de Combustível',
		TelaCompraCombustivel_lFornecedor: 'Fornecedor',
		TelaCompraCombustivel_lTanqueCombustivel: 'Tanque de Combustível',
		TelaCompraCombustivel_lQuantidade: 'Quantidade',
		TelaCompraCombustivel_lValorTotal: 'Valor Total',
		TelaCompraCombustivel_lDataCompra: 'Data da Compra',
		TelaMovimentacaoCombustivel_lDataCompra: 'Data da Movimentação',
		TelaMovimentacaoCombustivel_lQuantidade: 'Quantidade',
		TelaMovimentacaoCombustivel_lNumeroTanqueCombustivelOrigem: 'Número Tanque de Combustível Origem',
		TelaMovimentacaoCombustivel_lNumeroTanqueCombustivelDestino: 'Número Tanque de Combustível Destino',
		TelaMovimentacaoCombustivel_lTanqueCombustivelOrigem: 'Tanque de Combustível Origem',
		TelaMovimentacaoCombustivel_lTanqueCombustivelDestino: 'Tanque de Combustível Destino',
		TelaPontoInteresse_lGrupo: 'Grupo',		
		TelaPontoInteresse_lCodigo: 'Código',
		TelaPontoInteresse_lNome: 'Nome',
		TelaPontoInteresse_lDescricao: 'Descrição',
		TelaPontoInteresse_lRaio: 'Raio',
		TelaPontoInteresse_lIdentificar: 'Identificar',
		TelaPontoInteresse_lEnviarAlerta: 'Enviar Alerta',
		TelaPontoInteresse_lInicioFimRota: 'Início/Fim Rota',
		TelaPontoInteresse_lIcone: 'Icone',
		TelaPontoInteresse_lTipo: 'Tipo',
		TelaPontoInteresse_lPoligono: 'Poligono',
		TelaPontoInteresse_lCirculo: 'Círculo',		
		TelaPontoInteresse_lLatitude: 'Latitude',
		TelaPontoInteresse_lLongitude: 'Longitude',
		TelaPontoInteresse_lRestricoes: 'Restrições',
		TelaPontoInteresse_lHorarioInicial: 'Horário Inicial',
		TelaPontoInteresse_lHorarioFinal: 'Horário Final',
		TelaPontoInteresse_lLimiteVelocidade: 'Limite Velocidade',
		TelaPontoInteresse_lAvisoTempoPermanencia: 'Aviso de Tempo de Permanência',
		TelaPontoInteresse_lAtivo: 'Ativo',
		TelaPontoInteresse_lFaixaPermanenciaVerde: 'Faixa Verde',
		TelaPontoInteresse_lFaixaPermanenciaAmarela: 'Faixa Amarela',
		TelaPontoInteresse_lFaixaPermanenciaVermelha: 'Faixa Vermelha',
		TelaPontoInteresse_lIntervaloEmMinutos: 'Intervalo em Minutos',
		TelaMensagemTeclado_lVeiculo: 'Veículo',
		TelaMensagemTeclado_lMotorista: 'Motorista',
		TelaMensagemTeclado_lTipoMensagem: 'Tipo',
		TelaMensagemTeclado_lMensagem: 'Mensagem',
		TelaMensagemTeclado_lTempoAlertaDescanso: 'Tempo para Alerta',
		TelaMensagemTeclado_lDataHora: 'Data/Hora',
		TelaMensagemTeclado_lLocalizacao: 'Localização',
		TelaMensagemTeclado_lJustificativa: 'Justificativa',
		TelaMensagemTeclado_Msg1_PopupMotoristas: ' Selecione o motorista do evento',
		TelaMensagemTeclado_lGerar: 'Gerar',
		TelaMensagemTeclado_lSenha: 'Senha',
		TelaMensagemTeclado_lContraSenha: 'Contra-Senha',
		TelaGrupoveiculo_lNome: 'Nome',
		TelaGrupoveiculo_lLogin: 'Login',
		TelaGrupoveiculo_lSenha: 'Senha',
		TelaGrupoveiculo_lDescricao: 'Descrição',
		TelaGrupoveiculo_lPermissoes: 'Permissões',
		TelaGrupoveiculo_lMaster: 'Master',
		TelaGrupoveiculo_lPodeSeAlterar: 'Pode se Alterar',
		TelaGrupoveiculo_lPodeBloquear: 'Pode Bloquear',
		TelaGrupoveiculo_lVisualizarRelatorios: 'Visualizar Relatórios',
		TelaGrupoveiculo_lVisualizarPercursos: 'Visualizar Percursos',
		TelaGrupoveiculo_lVisualizarAvisos: 'Visualizar Avisos',
		TelaGrupoveiculo_lVersaoSistema: 'Versão do Sistema',
		Menu_ControleViagens: 'Controle de Viagens',
		Menu_ControleEntradaSaida: 'Controle de Entrada e Saída',
		Menu_ControleRotasViagens: 'Rotas de Viagens',
		Menu_ControleZonasViagens: 'Zonas de Viagens',
		Menu_ControleEquipamentosViagens: 'Equipamentos de Viagens',
		Menu_ControleViagens_EventosMonitriip: 'Eventos do Monitriip',
		TelaZonasViagens_lNome: 'Nome',
		TelaControleViagemRapida_lPontoInteresse : 'Ponto de Interesse',
		TelaRotasControleViagem_lNome: 'Nome',
		TelaRotasControleViagem_msg1: 'Informe um endereço ou selecione um ponto de interesse',
		TelaRotasControleViagem_lNovoLocal: 'Local',
		TelaRotasControleViagem_lPontoInteresse: 'Ponto de Interesse',
		TeleControleViagem_lStatusViagem: 'Status Viagem',
		TeleControleViagem_lDataViagem: 'Data',
		TeleControleViagem_lIdentificador: 'Identificador',
		TeleControleViagem_lMotorista: 'Motorista',
		TeleControleViagem_lAjudantes: 'Ajudantes',
		TeleControleViagem_lZona: 'Zona',
		TeleControleViagem_lDataSaida: 'Data de Saída',
		TeleControleViagem_lDataRetorno: 'Data de Retorno',
		TeleControleViagem_lPeriodo: 'Periodo',
		TeleControleViagem_lDe: 'DE',
		TeleControleViagem_lPara: 'PARA',
		TeleControleViagem_lRegiaoAtendida: 'Região Atendida',
		TeleControleViagem_lQtdCidades: 'Qtd Cidades',
		TeleControleViagem_lQtdEntregas: 'Qtd Entregas',
		TeleControleViagem_lPeso: 'Peso',
		TeleControleViagem_lValor: 'Valor',
		TeleControleViagem_lValorAdiantamento: 'Adiantamento Custo',
		TeleControleViagem_lDistancia: 'Distância',
		TeleControleViagem_lPolilinha: 'Trajeto',
		TeleControleViagem_BtnControleRota: 'Controlar Percurso ',
		TeleControleViagem_Msg_DeParaObrigatorio: 'Selecione o ínicio (DE) e o destino(PARA) da viagem para habilitar o controle do percurso ',
		TeleControleViagem_lPermitirIniciarAntesPlanejado: 'Permitir iniciar antes ',
		TeleControleViagem_lEquipamento: 'Equipamento',
		TeleControleViagem_lStatusAceiteMotoristaa: 'Aceite Motorista',
		TeleControleViagem_lPermitirSomenteComAceite: 'Iniciar somente com aceite',
		TeleControleViagem_lAlterarMotoristaNoVeiculo: 'Alterar motorista ao iniciar',
		TelaZonaRoteirizacao_lCodigo: 'Código',
		TelaZonaRoteirizacao_lNome: 'Nome',
		TelaZonaRoteirizacao_lPesoMinimo: 'Peso Mínimo',
		TelaZonaRoteirizacao_lMinimoPesoVeiculo: '% Mínimo Peso Veículo',
		TelaZonaRoteirizacao_lMaximoPesoVeiculo: '% Máximo Peso Veículo',
		TelaZonaRoteirizacao_lDesconsiderarDeslocamento: 'Desconsiderar deslocamento viagem',
		TelaZonaRoteirizacao_lListaVeiculos: 'Veículos permitidos',
		TelaZonaRoteirizacao_Msg_AreaZona: 'Área da zona incompleta',
		TelaZonaRoteirizacao_btnLimparZona: 'LimparZona',
		TelaZonaRoteirizacao_Msg_VeiculoJaExistente: 'Veículo já associado a zona',
		TelaZonaRoteirizacao_lTextoImportacao: 'Arquivo de zonas para importação',
		TelaZonaRoteirizacao_lImportacaoInstrucao: 'O arquivo CSV deve ter como separador o ; (ponto e virgula) e a sequencia de coluna é CODIGO ;  NOME . A primeira linha do arquivo é considerada como cabeçalho. ',
		TelaLojaRoteirizacao_lCodigo: 'Código',
		TelaLojaRoteirizacao_lNome: 'Nome',
		TelaLojaRoteirizacao_lSenha: 'Senha',
		TelaLojaRoteirizacao_BtnImportar: 'Importar',
		TelaLojaRoteirizacao_lTextoImportacao: 'Arquivo de lojas para importação',
		TelaLojaRoteirizacao_lImportacaoInstrucao: 'O arquivo CSV deve ter como separador o ; (ponto e virgula) e a sequencia de coluna é CODIGO ;  NOME . A primeira linha do arquivo é considerada como cabeçalho. ',
		TelaVendedorRoteirizacao_lCodigo: 'Código',
		TelaVendedorRoteirizacao_lNome: 'Nome',
		TelaVendedorRoteirizacao_lStatus: 'Status',
		TelaVendedorRoteirizacao_lSenhaAcesso: 'Senha',
		TelaVendedorRoteirizacao_lTextoImportacao: 'Arquivo de vendedores para importação',
		TelaVendedorRoteirizacao_lImportacaoInstrucao: 'O arquivo CSV deve ter como separador o ; (ponto e virgula) e a sequencia de coluna é CODIGO ;  NOME . A primeira linha do arquivo é considerada como cabeçalho. ',
		TelaVendedorRoteirizacao_lEhArquivoControl: 'Arquivo do Contro ?',
		TelaVendedorRoteirizacao_BtnImportar: 'Importar',
		TelaTipoOcorrencia_lNome: 'Nome',
		TelaTipoOcorrencia_lErroMotorista: 'Erro do Motorista',
		TelaTipoOcorrencia_lErroConferente: 'Erro do Conferente',
		TelaTipoOcorrencia_lErroVendedor: 'Erro do Vendedor',
		TelaTipoOcorrencia_lPeso: 'Peso',
		TelaTipoOcorrencia_Msg_SelecioneUmaOpcao: 'Selecione pelo menos uma opção de tipo de erro',
		TelaPedido_lSemCelular: 'Sem celular',
		TelaPedido_lNaoRoteirizados: 'Não Roteirizados',
		TelaPedido_lVendedor: 'Vendedor',
		TelaPedido_lLoja: 'Loja',
		TelaPedido_lZona: 'Zona',
		TelaPedido_lStatus: 'Status',
		TelaPedido_lPedido: 'Pedido',
		TelaPedido_lCarregamento : 'Carregamento',
		TelaPedido_lLote: 'Lote',
		TelaPedido_lNumeroPedido: 'Número do Pedido',
		TelaPedido_lNumeroNotaFiscal: 'Número Nota Fiscal',
		TelaPedido_lNumeroCelular: 'Número Celular',
		TelaPedido_lData: 'Data',
		TelaPedido_lCompromissoEntrega: 'Compromisso de Entrega',
		TelaPedido_lRenegociacao: 'Renegocição da Entrega',
		TelaPedido_lQuantidade: 'Quantidade',
		TelaPedido_lValor: 'Valor',
		TelaPedido_lDescricao: 'Descrição',
		TelaPedido_lLiberadoParaSeparacao: 'Liberado para Separação',
		TelaPedido_lLiberadoParaRoteirizacao: 'Liberado para Roteirização',
		TelaPedido_lCliente: 'Cliente',
		TelaPedido_lEndereco: 'Endereço',
		TelaPedido_lRestricao: 'Restrições',
		TelaPedido_lPeso: 'Peso',
		TelaPedido_lVolume: 'Volume',
		TelaPedido_lHorarioAtendimento: 'Horário Disponível para Atendimento',
		TelaPedido_lHorarioAtendimentoInicial: 'Horário Inicial',
		TelaPedido_lHorarioAtendimentoFinal: 'Horário Final',
		TelaPedido_lTempoAtendimento: 'T. Atendimento',
		TelaEsqueciMinhaSenha_lTitulo: 'Esqueci Minha Senha',
		TelaEsqueciMinhaSenha_lSubTitulo: 'Informe o CPF/CNPJ e o email cadastrado',
		TelaEsqueciMinhaSenha_lCPFCNPJ: 'CPF/CNPJ',
		TelaEsqueciMinhaSenha_lEmail: 'E-mail',
		TelaEsqueciMinhaSenha_lRecuperarSenha: 'Recuperar Senha',
		TelaTrocarSenha_lTitulo: 'Alteração de Senha',
		TelaTrocarSenha_lSubTitulo: 'Informe os dados e clique em Gravar Nova Senha',
		TelaTrocarSenha_lCPFCNPJ: 'Informe o CPF/CNPJ',
		TelaTrocarSenha_lSenhaAtual: 'Seha atual',
		TelaTrocarSenha_lNovaSenha: 'Nova Senha',
		TelaTrocarSenha_lConfirmacaoNovaSenha: 'Confirmação nova senha',
		TelaTrocarSenha_BtnGravarNovaSenha: 'Gravar Nova Senha',
		TelaTrocarSenha_Msg_MinimoSenha: 'Senha deve ter pelo menos 5 caracteres',
		TelaTrocarSenha_Msg_ConfirmaSenhaDiferente: 'Confirmação está diferente da nova senha',
		TelaRoteirizacao_lVeiculo: 'Veículo',
		TelaRoteirizacao_lMotorista: 'Motorista',
		TeleRoteirizacao_lPedido: 'Pedido',
		TeleRoteirizacao_lCarregamento: 'Carregamento',
		TelaRoteirizacao_lStatus: 'Status',
		TelaRoteirizacao_lDataInicioPlanejada: 'Data Início',
		TelaRoteirizacao_lDataFimPlanejada: 'Data Fim',
		TelaRoteirizacao_lDataInicioRealizado: 'Data Início',
		TelaRoteirizacao_lDataFimRealizado: 'Data Fim',
		TelaRoteirizacao_lPoISaida: 'Ponto de Saída',
		TelaRoteirizacao_lPoIRetorno: 'Ponto de Retorno',
		TelaRoteirizacao_lDistanciaPrevista: 'Distancia Prevista',
		TelaRoteirizacao_lTempoEstimado: 'Tempo Estimado',
		TelaRoteirizacao_lValorDevolvido: 'Valor Devolvido',
		TelaRoteirizacao_lSincronizacao: 'Sincronização',
		TelaRoteirizacao_Btn_RemoveSincronizacao: 'Remover Sincronização',
		TelaRoteirizacao_Msg_RotaDoRoteirizador: 'Rota criada pelo roteirizador deve ser modificada pelo módulo de roteirização.',
		TelaRoteirizacao_lValor: 'Valor Transportado',
		TelaRoteirizacao_lQtdItinerarios: 'Quantidade de Itinerarios',
		TelaRoteirizacao_lPeso: 'Peso',
		TelaRoteirizacao_lVolume: 'Volume',
		TelaItinerario_lVendedor: 'Vendedor',
		TelaItinerario_lLoja: 'Loja',
		TelaItinerario_lZona: 'Zona',
		TelaItinerario_lStatus: 'Status',
		TelaItinerario_lCarregamento : 'Carregamento',
		TelaItinerario_lVeiculo: 'Veiculo',
		TelaItinerario_lMotorista: 'Motorista',
		TelaItinerario_lNumeroPedido: 'Número do Pedido',
		TelaItinerario_lNumeroNotaFiscal: 'Nota Fiscal',
		TelaItinerario_lDataPedido: 'Data do Pedido',
		TelaItinerario_lDataItinerario: 'Data do Itinerario',
		TelaItinerario_lQuantidade: 'Quantidade',
		TelaItinerario_lValor: 'Valor',
		TelaItinerario_lDescricao: 'Descrição',
		TelaItinerario_lCliente: 'Cliente',
		TelaItinerario_lEndereco: 'Endereço',
		TelaItinerario_lRestricao: 'Restrições',
		TelaItinerario_lPeso: 'Peso',
		TelaItinerario_lVolume: 'Volume',
		TelaItinerario_lHorarioAtendimento: 'Horário Disponível para Atendimento',
		TelaItinerario_lHorarioAtendimentoInicial: 'Horário Inicial',
		TelaItinerario_lHorarioAtendimentoFinal: 'Horário Final',
		TelaItinerario_lTempoAtendimento: 'T. Atendimento',
		TelaItinerario_lDataEntrega : 'Data da Entrega',
		TelaItinerario_lNotaTablet : 'Nota do Aplicativo',
		TelaItinerario_lNotaSMS : 'Nota do SMS',
		TelaItinerario_lTipoOcorrencia : 'Ocorrência',
		TelaRoteirizador_lListaPedidos: 'Lista de Pedidos',
		TelaRoteirizador_lLocalSaida: 'Local de saída',
		TelaRoteirizador_lLocalRetorno: 'Local de retorno',
		TelaRoteirizador_lDataRota: 'Data da Rota',
		TelaRoteirizador_lVeiculo: 'Veículos',
		TelaRoteirizador_lRestricoes: 'Restrições',
		TelaRoteirizador_lRestricoesPeso: 'Peso',
		TelaRoteirizador_lRestricoesVolume: 'Volume',
		TelaRoteirizador_lRestricoesZona: 'Zona',
		TelaRoteirizador_lRestricoesJanelaAtendimento: 'Janela de Atendimento',
		TelaRoteirizador_lRestricoesQtdMaxItens: 'Qtd Máx.Itens',
		TelaRoteirizador_lRestricoesAgruparZona: 'Agrupar Zona',
		TelaRoteirizador_lRestricoesAgruparVendedor: 'Agrupar Vendedor',
		TelaRoteirizador_lJornadaInicio: 'Jornada Início',
		TelaRoteirizador_lIntervaloIncio: 'Intervalo Início',
		TelaRoteirizador_lIntervaloFim: 'Intervalo Fim',
		TelaRoteirizador_lJornadaFim: 'Jornada Fim',
		TeleAlmoxarifadoPneu_lDescricao: 'Descrição',
		TeleFabricantePneu_lNome: 'Nome',
		TelaMotivoSucateamento_lDescricao: 'Descricao',
		TelaDimensaoPneu_lAplicacao: 'Aplicação',
		TelaDimensaoPneu_lLargura: 'Largura',
		TelaDimensaoPneu_lPerfil: 'Perfil',
		TelaDimensaoPneu_lAro: 'Aro',
		TelaDimensaoPneu_lRadial: 'Radial',
		TelaBandaRodagemPneu_lFabricante: 'Fabricante',
		TelaBandaRodagemPneu_lDescricao: 'Descrição',
		TelaBandaRodagemPneu_lTipoDesenho: 'Tipo Desenho',
		TelaModeloPneu_lDescricao: 'Descrição',
		TelaModeloPneu_lFabricante: 'Fabricante',		
		TelaModeloPneu_lDimensao: 'Dimensão',
		TelaModeloPneu_lSulco: 'Sulco',
		TelaModeloPneu_lSulcoMinimo: 'Sulco Mínimo',
		TelaModeloPneu_lPressaoRecomendada: 'Pressão Recomendada',
		TelaModeloPneu_lComCamera: 'Possui Camera',
		TelaModeloPneu_Msg_SulcoMinimoInvalido: 'O Sulco mínimo deve ser menor que o Sulco',
		TelaModeloPneu_lPressaoMinima: 'Pressão Mínima',
		TelaModeloPneu_lPressaoMaxima: 'Pressão Máxima',
		TelaPneu_lNumeroFogo: 'Numero de Fogo',
		TelaPneu_lDOT: 'DOT',
		TelaPneu_lSerie: 'Série',
		TelaPneu_lModelo: 'Modelo',
		TelaPneu_lDataMovimentacao: 'Data da Movimentação',
		TelaPneu_lTipoAquisicao: 'Tipo de Aquisição',
		TelaPneu_lVida: 'Vida',
		TelaPneu_lBandaRodagem : 'Banda de Rodagem',
		TelaPneu_lSulco: 'Sulco Atual',
		TelaPneu_lControladoPor: 'Controlado Por',
		TelaPneu_lKMRodado: 'Km Rodado',
		TelaPneu_lAlmoxarifado: 'Amoxarifado',
		TelaPneu_lFornecedor: 'Fornecedor',
		TelaPneu_lDocumentoNFE: 'Doc./NF-e',
		TelaPneu_lDataEmissaoDocumento: 'Emissão',
		TelaPneu_lValorUnitario: 'Valor',
		TelaPneu_lStatus: 'Status',
		TelaPneu_lVeiculo: 'Veículo',
		TelaInspecaoPneu_lNomeFogo: 'Número de Fogo',
		TelaInspecaoPneu_lFabricante: 'Fabricante',
		TelaInspecaoPneu_lModelo: 'Modelo',
		TelaInspecaoPneu_lData: 'Data',
		TelaInspecaoPneu_lOdometro: "Odômetro (km)",
		TelaInspecaoPneu_lPressao: 'Pressão Aferida',
		TelaInspecaoPneu_lPressaoRecomendada: 'Pressão Recomendada',
		TelaInspecaoPneu_lSulcoAtual_Medida1: 'Sulco Atual - Medida 1',
		TelaInspecaoPneu_lSulcoAtual_Medida2: 'Sulco Atual - Medida 2',
		TelaInspecaoPneu_lSulcoAtual_Medida3: 'Sulco Atual - Medida 3',
		TelaInspecaoPneu_lSulcoMinimo: 'Sulco Mínimo',
		TelaInspecaoPneu_Msg_Instrucao: 'Clique no pneu desejado para informar os dados da inspeção',
		TeleTipoDespesa_lTipo: 'Tipo',
		TelaTipoReceita_lTipo: 'Tipo',
		TeleEquipamentoViagem_lTipo: 'Tipo',
		TeleEquipamentoViagem_lPlaca: 'Placa',
		TeleEquipamentoViagem_lStatus: 'Status',
		TeleEventoMonitriip_lVeiculo: 'Veículo',
		TeleEventoMonitriip_lOperacao: 'Operação',
		TeleEventoMonitriip_lDataHora: 'Data/Hora',
		TeleEventoMonitriip_lIMEI : 'IMEI',
		TeleEventoMonitriip_lLatitude : 'Latitude',
		TeleEventoMonitriip_lLongitude : 'Longitude',
		TeleEventoMonitriip_lCPFMotorista : 'CPF Motorista',
		TeleEventoMonitriip_lTipoEvento : 'Tipo Evento',
		TeleEventoMonitriip_lAutorizacaoViagem : 'Autorização Viagem',
		TeleEventoMonitriip_lTipoRegistroViagem : 'Tipo Registro Viagem',
		TeleEventoMonitriip_lMotivoParada : 'Motivo Parada',
		TeleEventoMonitriip_lTipoRegistroEvento : 'Tipo Registro Evento',
		TeleEventoMonitriip_lSentidoLinha : 'Sentido Linha',
		TeleEventoMonitriip_lIdentificacaoLinha : 'Identificação Linha',
		TeleEventoMonitriip_lCodigoTipoViagem : 'Código Tipo Viagem',
		TeleEventoMonitriip_lDataProgramaViagem : 'Data Programada Viagem',
		TeleEventoMonitriip_lHoraProgramadaViagem : 'Hora Programada Viagem',
		TeleEventoMonitriip_lDataRecebimento : 'Data Recebimento',
		TeleEventoMonitriip_lDataEnvioANTT : 'Data envio ANTT',
		TeleEventoMonitriip_lProcessado : 'Processado',
		TelaTipoItemAgendaEvento_codigo : 'Código',
		TelaTipoItemAgendaEvento_descricao : 'Descrição',
		TelaGrupoDespesa_codigo : 'Código',
		TelaGrupoDespesa_nome : 'Nome',
		TelaGrupoReceita_codigo : 'Código',
		TelaGrupoReceita_nome : 'Nome',	
		TelaSomAviso_lTipoAviso: 'Tipo do Aviso',
		TelaSomAviso_lNomeArquivoSom: 'Som',
		Menu_ControleEstoque_CategoriaProduto: 'Categorias de Peças',
		TelaControleEstoque_CategoriaProduto_lNome: 'Nome',
		TelaControleEstoque_CategoriaProduto_lDescricao: 'Descrição',
		Menu_ControleEstoque_Deposito: 'Depósitos de Peças',		
		TelaControleEstoque_Deposito_lNome: 'Nome',
		TelaControleEstoque_Deposito_lDesconsiderarSaldo: 'Desconsiderar Saldo',
		Menu_ControleEstoque_Produto: 'Peças',
		TelaControleEstoque_Produto_lCategoria: 'Categoria',
		TelaControleEstoque_Produto_lCodigo: 'Código',
		TelaControleEstoque_Produto_lNome: 'Nome',
		TelaControleEstoque_Produto_lDescricao: 'Descrição',
		TelaControleEstoque_Produto_lEstoqueMinimo: 'Estoque Mínimo',
		TelaControleEstoque_Produto_lEstoqueMaximo: 'Estoque Máximo',
		TelaControleEstoque_Produto_lSaldoAtual: 'Estoque Atual',
		TelaControleEstoque_Produto_lUnidadeDeMedida: 'Unidade de Medida',
		TelaControleEstoque_Produto_lDataHoraUltimaAtualizacao: 'Ultima Atualização',
		TelaControleEstoque_Produto_lStatus: 'Status',
		Menu_ControleEstoque_ComprasProduto: 'Compras de Peças',
		TelaControleEstoque_ComprasProduto_lFornecedor: 'Fornecedor',
		TelaControleEstoque_ComprasProduto_lDeposito: 'Depósito',
		TelaControleEstoque_ComprasProduto_lData: 'Data',
		TelaControleEstoque_ComprasProduto_lNotaFiscal: 'Nota Fiscal',
		TelaControleEstoque_ComprasProduto_lObservacao: 'Observação',
		TelaControleEstoque_ComprasProduto_lValor: 'Valor',
		TelaControleEstoque_ComprasProduto_lProduto: 'Peça',
		TelaControleEstoque_ComprasProduto_lQtd: 'Quantidade',
		TelaControleEstoque_ComprasProduto_lValorUnitario: 'Valor Unitário',
		Menu_ControleEstoque_MovimentacaoEstoque: 'Movimentação de Estoque',		
		TelaControleEstoque_MovimentacaoEstoque_lTipoMovimentacao: 'Tipo Movimentação',
		TelaControleEstoque_MovimentacaoEstoque_lData: 'Data',
		TelaControleEstoque_MovimentacaoEstoque_lDepositoOrigem: 'Depósito Origem',
		TelaControleEstoque_MovimentacaoEstoque_lDepositoDestino: 'Depósito Destino',
		TelaControleEstoque_MovimentacaoEstoque_lObservacao: 'Observação',
		TelaControleEstoque_MovimentacaoEstoque_lVeiculoOrigem: 'Veículo Origem',
		TelaControleEstoque_MovimentacaoEstoque_lVeiculoDestino: 'Veículo Destino',
		TelaTipoOcorrenciasVeiculo_lNome: 'Nome',
		TelaTipoOcorrenciasVeiculo_lAtivo: 'Ativo',
		TelaOcorrenciasVeiculo_lVeiculo: 'Veiculo',
		TelaOcorrenciasVeiculo_lMotorista: 'Motorista',
		TelaOcorrenciasVeiculo_lTipoOcorrencia: 'Tipo da Ocorrência',
		TelaOcorrenciasVeiculo_lDataHora: 'Data/Hora',
		TelaOcorrenciasVeiculo_lDescricao: 'Descrição',
		TelaOcorrenciasVeiculo_lStatus: 'Status',
		TelaOcorrenciasVeiculo_lDataHoraCadastro: 'Data/Hora do Cadastro',
		TelaModeloCheckList_codigo : 'Nome',
		TelaModeloCheckList_descricao : 'Descrição',
		TelaModeloCheckList_ativo : 'Ativo',
		TelaModeloCheckList_dataCriacao : 'Criado',
		TelaModeloCheckList_dataAlteracao : 'Alterado',
		TelaItemModeloCheckList_nome : 'Titulo',
		TelaItemModeloCheckList_descricao : 'Descrição',
		TelaItemModeloCheckList_obrigatorio : 'Obrigatório',
		TelaItemModeloCheckList_exigirFotoSeReprovado : 'Exigir Foto',
		TelaItemModeloCheckList_exigirObservacaoSeReprovado : 'Exigir Observação',
		TelaItemModeloCheckList_abrirOcorrenciaSeReprovado : 'Abrir Ocorrência',
		TelaItemModeloCheckList_exigirFotoSeAprovado : 'Exigir Foto',
		TelaItemModeloCheckList_exigirObservacaoSeAprovado : 'Exigir Observação',
		TelaItemModeloCheckList_abrirOcorrenciaSeAprovado : 'Abrir Ocorrência',
		TelaItemModeloCheckList_seReprovado : 'Se reprovado',
		TelaItemModeloCheckList_seAprovado : 'Se Aprovado',
		TelaVeiculoExterno_marca: 'Marca',
		TelaVeiculoExterno_modelo: 'Modelo',
		TelaVeiculoExterno_placa: 'Placa',
		TelaVeiculoExterno_cor: 'Cor',
		TelaVeiculoExterno_nomeMotorista: 'Nome Motorista',
		TelaVeiculoExterno_ativo: 'Ativo',
		TelaVeiculoExterno_dataHoraCadastro: 'Data/Hora Cadastro',
		TelaVeiculoExterno_usuario: 'Usuário',
		TelaPerfilCoresVelocidadePercurso_nome: 'Nome',
		TelaPerfilCoresVelocidadePercurso_velocidadeFaixa1: ' Velocidade Faixa 1',
		TelaPerfilCoresVelocidadePercurso_velocidadeFaixa2: ' Velocidade Faixa 2',
		TelaPerfilCoresVelocidadePercurso_velocidadeFaixa3: ' Velocidade Faixa 3',
		TelaPerfilCoresVelocidadePercurso_velocidadeFaixa1Inicio: ' Velocidade Inicio Faixa 1',
		TelaPerfilCoresVelocidadePercurso_velocidadeFaixa2Inicio: ' Velocidade Inicio Faixa 2',
		TelaPerfilCoresVelocidadePercurso_velocidadeFaixa3Inicio: ' Velocidade Inicio Faixa 3',
		TelaPerfilCoresVelocidadePercurso_velocidadeFaixa1Fim: ' Velocidade Fim Faixa 1',
		TelaPerfilCoresVelocidadePercurso_velocidadeFaixa2Fim: ' Velocidade Fim Faixa 2',
		TelaPerfilCoresVelocidadePercurso_velocidadeFaixa3Fim: ' Velocidade Fim Faixa 3',
		Mensagem_Erro_Intersecao_Faixa1_Faixa2: "La velocidad final del Rango 1 no puede ser mayor o igual a la velocidad inicial del Rango 2.",
		Mensagem_Erro_Intersecao_Faixa2_Faixa3: "La velocidad final del Rango 2 no puede ser mayor o igual a la velocidad inicial del Rango 3.",
		Mensagem_Erro_Ordem_Faixa1: "La velocidad inicial del Rango 1 debe ser menor que la velocidad final.",
		Mensagem_Erro_Ordem_Faixa2: "La velocidad inicial del Rango 2 debe ser menor que la velocidad final.",
		Mensagem_Erro_Ordem_Faixa3: "La velocidad inicial del Rango 3 debe ser menor que la velocidad final."	
	},	
	pt: {
		Ativo: 'Ativo',
		PoliticaPrivacidade: 'Politica de Privacidade',
		SelecionarTodos: 'Selecionar Todos',
		DesselecionarTodos: 'Deselecionar Todos',
		Sair: 'Sair',
		Dashboard: 'Dashboard',
		DashboardVeiculos: 'Veículos',
		DashboardMotoristas: 'Motoristas',
		DashboardTelemetria: 'Telemetria',
		DashboardCameras: 'Video Telemetria',
		DashboardDespesas: 'Despesas',
		Periodo: 'Período',
		Sim: 'Sim',
		Nao: 'Não',
		Dia_Semana_Seg: 'Segunda',
		Dia_Semana_Ter: 'Terça',
		Dia_Semana_Qua: 'Quarta',
		Dia_Semana_Qui: 'Quinta',
		Dia_Semana_Sex: 'Sexta',
		Dia_Semana_Sab: 'Sabado',
		Dia_Semana_Dom: 'Domingo',
		Atencao: 'Atenção',
		Erro: 'Erro',
		Mapa: 'Mapa',
		Grid: 'Grid',
		Percursos: 'Percursos',
		Avisos: 'Avisos',
		Tipo_Aviso: 'Tipo do Aviso',
		Frotas: 'Frotas',
		Viagens: 'Viagens',
		Pneus: 'Pneus',
		Roteirizacao: 'Roteirização',
		Relatorios: 'Relatórios',
		Configuracao: 'Configuração',
		Bloqueio: 'Bloqueio',
		Veiculo: 'Veículo',
		Veiculos: 'Veículos',
		Placa: 'Placa',
		Motorista: 'Motorista',		
		KmhParado: 'Km/h - Parado',
		Sensor: 'Sensor',
		Localizacao: 'Localização',
		Parado: 'Parado',
		Desatualizado: 'Desatualizado',
		AlertaParado: 'Alerta Parado',
		ComSensor: 'Com Sensor',		
		Acesso: 'Acesso',		
		MensagemAcesso: 'Informe seus dados e clique em entrar.',
		TelaLogin_phCPFCNPJ: 'Informe o seu CPF ou CNPJ ou login',
		TelaLogin_lLembrarSenha: 'Salvar dados de login',
		TelaLogin_lEsqueciSenha: 'Esqueci minha senha',
		TelaLogin_lEntrar: 'Entrar',
		TelaLogin_lTrocarSenha: 'Trocar Senha',		
		Mensagem_LoginInvalido: 'O login e/ou senha informados são inválidos.',
		Mensagem_Login_Bloqueado: 'Cliente bloqueado. Favor entrar em contato com a {nomeCentral} {telefoneCentral}',
		NenhumVeiculoEncontrado: 'Nenhum veículo encontrado.',
		NenhumEquipamentoEncontrado: 'Nenhum equipamento encontrado',
		NenhumMotoristaEncontrado: 'Nenhum motorista encontrado',
		Tooltipo_Exibir_Cidade: 'Exibir o nome da cidade',
		Tooltipo_Exibir_Endereco: 'Exibir o endereço completo',
		Tooltip_Qtd_Veiculos: 'Quantidade de veículos rastreados',
		Tooltip_Filtro_Parados: 'Exibir somente os veículos parados',
		Tooltip_Filtro_Desatualizados: 'Exibir somente os veículos desatualizados',
		Tooltip_Filtro_AlertaParados: 'Exibir somente os veículos com alerta de tempo parado',
		Tooltip_Filtro_ComSensor: 'Exibir somente os veículos com sensor',
		Tooltip_Filtro_ComControleViagem: 'Exibir somente os veículos que estão em Viagem Iniciada',
		Aviso: 'Aviso',
		Descricao: 'Descrição',
		Hora: 'Hora',
		AvisosDoDia: 'Avisos do Dia',
		Tooltip_Qtd_Avisos: 'Quantidade de avisos',
		Mensagem_Ver_Todos_Avisos_Dia: 'Ver todos os avisos do dia',
		Cidade: 'Cidade',
		PopUp_AgruparPorCidade: 'Veículos por cidade',
		Pesquisa: 'Pesquisar',
		LimparFiltros: 'Limpar filtro',
		ExportarParaCSV: 'Exportar para CSV',
		Novo: 'Novo',
		Filtros: 'Filtros',
		Qtd: 'Qtd',
		Divisao: 'Divisão',
		Divisao_Veiculo: 'Divisão de Veículos',
		Divisao_Motorista: 'Divisão de Motoristas',
		Imprimir: 'Imprimir',
		Agrupar: 'Agrupar',
		Fechar: 'Fechar',
		PontosInteresse: 'Pontos de Interesse',
		AgGrid_Contains: 'Contém',
		AgGrid_notContains: 'Não contém',
        AgGrid_startsWith: 'Inicia com',
        AgGrid_endsWith: 'Termina com ',
        AgGrid_andCondition: 'E',
        AgGrid_orCondition: 'OU',
        AgGrid_filters: 'Filtros',
        AgGrid_equals: 'Igual',
		AgGrid_notEqual: 'Diferente',
		AgGrid_filterOoo: 'Filtrar ...',
		Exibidos: 'Exibido(s)',
		Gravar_Exibidos:'Gravar exibidos',
		Perimetros: 'Perímetros',
		Btn_Gravar: 'Gravar',
		Btn_Limpar: 'Limpar',
		Btn_Voltar: 'Voltar',
		Btn_Excluir: 'Excluir',
		Btn_Localizar_Endereco: 'Localizar Endereço',
		Btn_Fechar: 'Fechar',
		Btn_OK: 'OK',
		Btn_CentralizarPerimetro: 'Centralizar Perímetro',
		Btn_Importar_KML: 'Importar KML',
		Btn_Ativar: 'Ativar',
		Btn_Desativar: 'Desativar',
		Btn_Bloquear: 'Bloquear',
		Btn_Desbloquear: 'Desbloquear',
		Btn_Inserir: 'Inserir',
		Btn_InserirLimpar: 'Inserir e Limpar',
		Btn_Importar: 'Importar',
		Cor_Localidade: 'Cor Localidade',
		Titulo_Corrigir_Erros: 'Favor corrigir os seguinte(s) erro(s):',
		Mensagem_Erro_Obrigatorio: 'obrigatório',
		Mensagem_Erro_Invalido: 'inválido',
		TelaMotorista_lNome: 'Nome',
		TelaMotorista_lMatricula: 'Matricula',
		TelaMotorista_lCPF: 'CPF',
		TelaMotorista_lRG: 'RG',
		TelaMotorista_lCNH: 'CNH',
		TelaMotorista_lCategoriaCNH: 'Categoria',
		TelaMotorista_lValidadeCNH: 'Validade CNH',
		TelaMotorista_lValidadeExameToxicologico: 'Validade Exame Toxicológico',
		TelaMotorista_lValidadeMOPP: 'Validade MOPP',
		TelaMotorista_lChaveiroCartao: 'Chaveiro/Cartão',
		TelaMotorista_lDataHoraInicioUsoCartao: 'Data/Hora Início do uso do chaveiro/cartão',
		TelaMotorista_lSenha: 'Senha',
		TelaMotorista_lEnderecos: 'Endereços',
		TelaMotorista_lTelefones: 'Telefones',
		TelaMotorista_lAtivo: 'Ativo',
		TelaMotorista_Mensagem_Erro_1: 'Informe a data e a hora de início de uso do chaveiro com este motorista',
		TelaMotorista_lImportacaoInstrucao: 'O arquivo CSV deve ter como separador o ; (ponto e virgula) e a sequencia de coluna é NOME ;  MATRICULA ; CPF ; RG ; CNH ; CATEGORIA ; VALIDADE CNH (formato dd/MM/yyyy) ; ENDERECO; TELEFONES ; CODIGO CHAVEIRO ; DATA ATIVACAO (formato dd/MM/yyyy HH:mm:ss) ;',
		TelaMotorista_lImportacaoInstrucao2: 'A primeira linha do arquivo é considerada como cabeçalho.',
		TelaMotorista_lImportacaoInstrucao3: 'Os motoristas serão atualizados caso tenha codigo do chaveiro, a matricula, cpf ou nome já cadastrado previamente. Para cadastrar o motorista com chaveiro a data de ativação do chaveiro é obrigatória. Se informado apenas o código do chaveiro, a plataforma apenas tentará atualizar.',
		TelaCorLocalidade_lNome: 'Nome da Localidade',
		TelaDivisao_lCodigo: 'Codigo',	
		TelaDivisao_lNome: 'Nome',	
		TelaCategoriaAviso_lNome: 'Nome',	
		TelaCategoriaAviso_lTipo: 'Tipo',
		TelaPontuacaoAviso_lTipoAviso: 'Tipo do Aviso',
		TelaPontuacaoAviso_lTipoCategoria: 'Categoria do Aviso',
		TelaPontuacaoAviso_lPontuacao: 'Pontuação',
		Menu_Alterar_Veiculo: 'Alteração Veículo',
		Menu_Alterar_Dados_Contato_Veiculo: 'Alteração Dados Contato',
		TelaAlterarVeiculo_lCategoria: 'Categoria',
		TelaAlterarVeiculo_lDivisao: 'Divisão',
		TelaAlterarVeiculo_lTipoVeiculo: 'Tipo Veículo',
		TelaAlterarVeiculo_lMarca: 'Marca',
		TelaAlterarVeiculo_lModelo: 'Modelo',
		TelaAlterarVeiculo_lModeloOutro: 'Outro Modelo',
		TelaAlterarVeiculo_lPlaca: 'Placa',
		TelaAlterarVeiculo_lMesVencto: 'Mês Vencto',
		TelaAlterarVeiculo_lLabel: 'Label',
		TelaAlterarVeiculo_lAnoFabricacao: 'Ano Fabricação',
		TelaAlterarVeiculo_lAnoModelo: 'Ano Modelo',
		TelaAlterarVeiculo_lCor: 'Cor',
		TelaAlterarVeiculo_lChassi: 'Chassi', 
		TelaAlterarVeiculo_lRenavam: 'Renavam',  	
		TelaAlterarVeiculo_lCondutor: 'Condutor', 
		TelaAlterarVeiculo_lKMl: 'KM/l', 
		TelaAlterarVeiculo_lLh: 'L/h', 
		TelaAlterarVeiculo_lHorimetro: 'Horímetro', 
		TelaAlterarVeiculo_lOdometro: 'Odômetro', 
		TelaAlterarVeiculo_lSenhaAcessoIndividual: 'Senha de Acesso Individual', 
		TelaAlterarVeiculo_lVelocidadeMinima: 'Velocidade Mínima km/h', 
		TelaAlterarVeiculo_lVelocidadeMaxima: 'Velocidade Máxima km/h', 
		TelaAlterarVeiculo_lLabelControleHorario: 'Controlar horários de uso dos veículos',
		TelaAlterarVeiculo_lMensagemControleHorario: 'Informe os horários permitidos de utilização do veículo',
		TelaAlterarVeiculo_lAvisarExcessoVelocidade: 'Avisar Excesso Velocidade',
		TelaAlterarVeiculo_lAvisarExcessoVelocidadeVia: 'Avisar Excesso Velocidade na Cidade',
		TelaAlterarVeiculo_lVeiculoEmManutencao: 'Veículo em manutenção',
		TelaAlterarVeiculo_lAvisarSaidaPerimetro: 'Avisar Saída Perímetro',
		TelaAlterarVeiculo_lAvisarVeiculoParado: 'Avisar Veículo Parado',
		TelaAlterarVeiculo_lTempoParada: "Tempo parada em minutos",
		TelaAlterarVeiculo_lLimitePressaoAcelerador: "Limite Pressão Acelerador",
		TelaAlterarVeiculo_lSelecionarPerimetro: "Selecione o perímetro",
		TelaAlterarVeiculo_lRPMMax: "RPM Máximo",
		TelaAlterarVeiculo_lTempoDirecaoMaximo: "Tempo Máximo de Direção",
		TelaAlterarVeiculo_lLigarAncoragem: "Ligar Ancoragem",
		TelaAlterarVeiculo_lAvisarVeiculoLigado: "Avisar Veículo Ligado",
		TelaAlterarVeiculo_lAvisarVeiculoDesligado: "Avisar Veículo Desligado",
		TelaAlterarVeiculo_lAvisarVeiculoParadoLigado: "Avisar Veículo Parado Ligado?",
		TelaAlterarVeiculo_lResponsavel1: "Responsável 1",
		TelaAlterarVeiculo_lResponsavel2: "Responsável 2",
		TelaAlterarVeiculo_lEmail1: "Email 1",
		TelaAlterarVeiculo_lEmail2: "Email 2",
		TelaAlterarVeiculo_lCelular1: "Celular 1",
		TelaAlterarVeiculo_lCelular2: "Celular 2",
		TelaAlterarVeiculo_lContatoEmergencia: "Contatos de Emergência",
		TelaAlterarVeiculo_lHoraGeracao: "Hora Geração",
		TelaAlterarVeiculo_lAnexarMapa: "Anexar Mapa ?",
		TelaAlterarVeiculo_lEnviarFinalSemana: "Enviar final de semana ?",
		TelaAlterarVeiculo_lTempoMinimoParada: "Tempo Mínimo ( minutos)",
		TelaAlterarVeiculo_lSoParadaLigado: "Só paradas ligado ?",
		TelaAlterarVeiculo_lSoEmPontosInteresse: "Só em pontos de interesse ?",
		TelaAlterarVeiculo_MensagemRota: 'Parâmetros utilizados na roteirização e aplicativo Minha Rota',
		TelaAlterarVeiculo_lSenhaAplicativoEntrega: 'Senha aplicativo de entrega',
		TelaAlterarVeiculo_lCapacidadePeso: 'Capacidade - Peso',
		TelaAlterarVeiculo_lCapacidadeVolume: 'Capacidade - Volume',
		TelaAlterarVeiculo_lCustoPorKM: 'Custo por KM',
		TelaAlterarVeiculo_lQtdMaximaItinerarios: 'Quantidade máxima de itinerários',
		TelaAlterarVeiculo_lLabelHorarioBloqueio: 'Bloqueio automático do veículo',
		TelaAlterarVeiculo_lMensagemHorarioBloqueio: 'Informe os horários que o veículo deve ser bloqueado e desbloqueado',
		TelaAlterarVeiculo_lMensagemVeiculoSemBloqueio: 'Este veículo não possui o acessório de bloqueio instalado.',
		TelaAlterarVeiculo_Btn_RepetirSegunda: 'Repetir Horário de Segunda',
		TelaAlterarVeiculo_Btn_RepetirSegundaAteSexta: 'Repetir Horário de Segunda até Sexta',
		TelaAlterarVeiculo_lCapacidadeTanque: 'Capacidade tanque ( litros )',
		TelaAlterarVeiculo_lAcessosDisponveis: 'ACESSOS DISPONÍVEIS',
		TelaAlterarVeiculo_lAcessosSelecionados: 'ACESSOS SELECIONADOS',
		TelaAlterarVeiculo_lTiposCombustiveisDisponiveis: 'TIPOS DE COMBUSTÍVEIS DISPONÍVEIS',
		TelaAlterarVeiculo_lTiposCombustiveisDoVeiculo: 'TIPOS DE COMBUSTÍVEIS DO VEÍCULO',
		TelaAlterarVeiculo_lMensagemFaixasRPM: 'Configure as faixas de RPM do veículo',
		TelaAlterarVeiculo_lFaixa1RPM: 'Faixa 1',
		TelaAlterarVeiculo_lFaixa2RPM: 'Faixa 2',
		TelaAlterarVeiculo_lFaixa3RPM: 'Faixa 3',
		TelaAlterarVeiculo_lFaixa4RPM: 'Faixa 4',
		TelaAlterarVeiculo_lFaixa5RPM: 'Faixa 5',
		TelaAlterarVeiculo_lAcimaFaixa5RPM: 'Acima da Faixa 5',
		TelaAlterarVeiculo_lAtualizacaoRPMPorMinuto: 'Atualizações por minuto',
		TelaAlterarVeiculo_Msg1_PopupMotoristas: 'Selecione o novo motorista para o veículo.',
		TelaAlterarVeiculo_Msg2_PopupMotoristas: 'Clique nos motoristas que são autorizados a utilizar o veículo.',
		TelaAlterarVeiculo_Mensagem_Erro_1: 'Acesso já cadastrado',
		TelaAlterarVeiculo_Mensagem_Erro_2: 'Tipo de combustível já selecionado',
		TelaAlterarVeiculo_Mensagem_Erro_3: 'Email 1 de envio do relatório de paradas',
		TelaAlterarVeiculo_Mensagem_Erro_4: 'Hora de envio do relatório de paradas',
		TelaAlterarVeiculo_Mensagem_Erro_5: 'Informe pelo menos um email para o envio do do relatório de paradas',
		TelaAlterarVeiculo_Mensagem_Erro_6: 'Email 2 de envio do relatório de paradas',
		TelaAlterarVeiculo_Mensagem_Erro_7: 'Email 1 de avisos',
		TelaAlterarVeiculo_Mensagem_Erro_8: 'Email 2 de avisos',
		TelaAlterarVeiculo_Mensagem_Erro_9: 'Informe o horário permitido para pelo menos um dia.',
		TelaAlterarVeiculo_Mensagem_Erro_10: 'Horário inválido de Segunda.',
		TelaAlterarVeiculo_Mensagem_Erro_11: 'Horário inválido de Terça.',
		TelaAlterarVeiculo_Mensagem_Erro_12: 'Horário inválido de Quarta.',
		TelaAlterarVeiculo_Mensagem_Erro_13: 'Horário inválido de Quinta.',
		TelaAlterarVeiculo_Mensagem_Erro_14: 'Horário inválido de Sexta.',
		TelaAlterarVeiculo_Mensagem_Erro_15: 'Horário inválido de Sábado.',
		TelaAlterarVeiculo_Mensagem_Erro_16: 'Horário inválido de Domingo.',
		TelaAlterarVeiculo_Mensagem_Erro_17: 'Informe o horário de bloqueio para pelo menos um dia.',
		TelaAlterarVeiculo_Mensagem_Erro_18: 'Horário de bloqueio inválido de Segunda.',
		TelaAlterarVeiculo_Mensagem_Erro_19: 'Horário de bloqueio inválido de Terça.',
		TelaAlterarVeiculo_Mensagem_Erro_20: 'Horário de bloqueio inválido de Quarta.',
		TelaAlterarVeiculo_Mensagem_Erro_21: 'Horário de bloqueio inválido de Quinta.',
		TelaAlterarVeiculo_Mensagem_Erro_22: 'Horário de bloqueio inválido de Sexta.',
		TelaAlterarVeiculo_Mensagem_Erro_23: 'Horário de bloqueio inválido de Sábado.',
		TelaAlterarVeiculo_Mensagem_Erro_24: 'Horário de bloqueio inválido de Domingo.',
		TelaAlterarVeiculo_Mensagem_Erro_25: 'Valor inválido para o mês de vencimento da placa. Digite um numero entre 1 e 12.',
		TelaAlterarVeiculo_Mensagem_Erro_26: 'Valor inválido para o ano de fabricação. Digite um valor acima de 1900.',
		TelaAlterarVeiculo_Mensagem_Erro_27: 'Valor inválido para o ano do modelo. Digite um valor acima de 1900.',
		TelaAlterarVeiculo_Mensagem_Erro_28: 'O Tempo Máximo de Direção deve ser de pelo menos 60 minutos.',		
		TelaAlterarVeiculo_Mensagem_Erro_29: 'O início da faixa {p1} precisa ter o valor menor que o fim da faixa {p2}',
		TelaAlterarVeiculo_Mensagem_Erro_30: 'A faixa {p1} não pode ter interseção de valores com a faixa {p2}',
		TelaAlterarVeiculo_Mensagem_Erro_31: 'Informe o perímetro',
		TelaAlterarVeiculo_Mensagem_Erro_32: 'Informe a velocidade mínima para considerar transito em horário não permitido',
		TelaAlterarVeiculo_MensagemRelatorioDiario: 'Preencha os dados dessa aba se você deseja receber um relatório diário com as paradas do dia anterior deste veículo.',
		TelaPerimetro_lNome: 'Nome',
		TelaPerimetro_lPerimetro: 'Perímetro',	
		TelaPerimetro_Mensagem: 'Informe o endereço para pesquisar',	
		TelaPerimetro_Mensagem_Erro_1: 'O perímetro deve conter pelo menos 3 pontos no mapa',	
		Menu_Perimetro: 'Perímetros',
		Mensagem_EnderecoNaoEncontrado: 'Endereço não encontrado',
		Menu_Atuadores: 'Atuadores',
		TelaAtuadores_Mensagem_AtivarSaida2: 'Selecione o veículo para ativar a saída 2',
		TelaAtuadores_Mensagem_AtivarSaida3: 'Selecione o veículo para ativar a saída 3',
		TelaAtuadores_lSaida2: 'Saída 2',
		TelaAtuadores_lSaida3: 'Saída 3',
		TelaBloqueio_Mensagem_BloquearDesbloquear: 'Selecione o veículo para bloquear/desbloquear',
		TelaBloqueio_lSenha: 'Informe a senha',
		TelaRelatorio_lPeriodoViagem: 'Período da Viagem',
		TelaRelatorio_lTipoDespesa: 'Tipo de Despesa',
		TelaRelatorio_lTipoReceita: 'Tipo de Receita',
		TelaRelatorio_lFornecedor: 'Fornecedor',
		TelaRelatorio_lCliente: 'Cliente',
		TelaRelatorio_lColunasDisponiveis: 'Colunas Disponíveis',
		TelaRelatorio_lColunasSelecionadas: 'Colunas Selecionadas',
		TelaRelatorio_lGrupoDespesa: 'Grupo Despesa',
		TelaRelatorio_lGrupoReceita: 'Grupo Receita',
		TelaRelatorio_lCategoriaPontoInteresse: 'Grupo Ponto de Interesse',
		TelaPessoasRFID_lMatricula: 'Matrícula',
		TelaPessoasRFID_lNome: 'Nome',
		TelaPessoasRFID_lCodigoChaveiro: 'Codigo Chaveiro/Cartão',
		TelaPessoasRFID_lStatus: 'Status',
		TelaPessoasRFID_lSetor: 'Setor',
		TelaAlterarVeiculoLote_lVeiculosDisponiveis: 'Veículos Disponíveis',
		TelaAlterarVeiculoLote_lVeiculosSelecionados: 'Veículos Selecionados',
		TelaAlterarVeiculoLote_Mensagem_Erro_1: 'Selecione pelo menos um veículo.',
		TelaCategoriaveiculo_lMenu: 'Categorias Veículos',
		TelaCategoriaveiculo_lDescricao: 'Descrição',
		TelaCategoriaveiculo_lControladoPor: 'Controlado Por',
		TelaCategoriaveiculo_lAroPneus: 'Aro Pneus',
		TelaCategoriaveiculo_lNumeroEstepes: 'Quantidade Estepes',
		TelaCategoriaveiculo_lEixos: 'Eixos',
		TelaCategoriaveiculo_lMensagem_Erro1: "Informe pelo menos 2 eixos",
		TelaCategoriaveiculo_lMensagem_Erro2p1: "O eixo ",
		TelaCategoriaveiculo_lMensagem_Erro2p2: " precisa ter pelo menos dois pneus selecionados.",
		TelaAgendaEventos_lTipo: 'Tipo',
		TelaAgendaEventos_lVeiculo: 'Veículo',
		TelaAgendaEventos_lNome: 'Nome',
		TelaAgendaEventos_lDescricao: 'Descrição',
		TelaAgendaEventos_lStatus: 'Status',
		TelaAgendaEventos_lEmail: 'E-mail',
		TelaAgendaEventos_lParametros: 'Parâmetros',
		TelaAgendaEventos_lDataEvento: 'Data do Evento',
		TelaAgendaEventos_lKM: 'KM',
		TelaAgendaEventos_lHorimetro: 'Horímetro',
		TelaAgendaEventos_lEnvioEmail: 'E-mail enviado em',
		TelaAgendaEventos_lHoraCadastro: 'Cadastrado em',
		TelaAgendaEventos_lTipoItemAgendaEvento: 'Tipo Item Evento',
		Menu_AgendaEventos: 'Agenda de Eventos',
		Menu_Despesas: 'Despesas',
		Menu_Receitas: 'Receitas',
		Menu_TipoDespesas: 'Tipo Despesas',
		Menu_TipoReceitas: 'Tipo Receitas',
		Menu_Fornecedores: 'Fornecedores',
		Menu_CateogoriaPontoInteresse: 'Grupo Ponto de Interesse',
		Menu_PontoInteresse: 'Ponto de Interesse',
		Menu_ImportarPontoInteresse: 'Importar Pontos de Interesse',
		Menu_TanquesCombustivel: 'Tanques de Combustível',
		Menu_CompraCombustivel: 'Compras de Combustível',
		Menu_MovimentacaoCombustivel: 'Movimentações de Combustível',
		Menu_Tipo_Item_Agenda_Eventos: 'Tipo Item Eventos',
		Menu_Tipo_Ocorrencia_Veiculos: 'Tipo Ocorrência de Veículos',
		Menu_Ocorrencia_Veiculos: 'Ocorrência de Veículos',
		TelaFornecedores_lNome: 'Nome',
		TelaFornecedores_lRazaoSocial: 'Razão Social',
		TelaFornecedores_lCPFCNPJ: 'CPF/CNPJ',
		TelaFornecedores_lEndereco: 'Endereço',
		TelaFornecedores_lTelefone: 'Telefone',
		TelaFornecedores_lEmail: 'E-mail',
		TelaFornecedores_lIsCliente: 'Cliente',
		TelaFornecedores_lIsFornecedor: 'Fornecedor',
		TelaFornecedores_lTextoImportacao: 'Importação de favorecidos por arquivo',
		TelaFornecedores_lImportacaoInstrucao: 'O arquivo CSV deve ter como separador o ; (ponto e virgula) e a sequencia de coluna é NOME ; CNPJ OU CPF; ENDEREÇO ; TELEFONE ; EMAIL ; SE CLIENTE ; SE FORNECEDOR . A primeira linha do arquivo é considerada como cabeçalho. Para as colunas SE CLIENTE ou SE FORNECEDOR, utilizar a letra S para SIM e N para não. ',
		TelaCategoriaPontoInteress_lNome: 'Nome',
		TelaCategoriaPontoInteress_lDescricao: 'Descrição',
		TelaCategoriaPontoInteress_lIcone: 'Icone',
		TelaReceitas_lVeiculo: 'Veículo',
		TelaReceitas_lTipo: 'Tipo',
		TelaReceitas_lRota: 'Rota',
		TelaReceitas_lCliente: 'Cliente',
		TelaReceitas_lNome: 'Nome',
		TelaReceitas_lDescricao: 'Descrição',
		TelaReceitas_lData: 'Data',
		TelaReceitas_lValor: 'Valor',
		TelaReceitas_lQuantidade: 'Quantidade',
		TelaReceitas_lMotorista: 'Motorista',
		TelaReceitas_Msg1_PopupMotoristas: 'Selecione o motorista',
		TelaReceitas_Msg1_PopupRotas: 'Selecione a rota',
		PopUpRotas_lPedido: 'Pedido',
		TelaDespesas_lVeiculo: 'Veículo',
		TelaDespesas_lTipo: 'Tipo',
		TelaDespesas_lRota: 'Rota',
		TelaDespesas_lIdentificador: 'Identificador',
		TelaDespesas_lViagem: 'Viagem',
		TelaDespesas_lFornecedor: 'Fornecedor',
		TelaDespesas_lGrupo: 'Grupo',
		TelaDespesas_lNome: 'Nome',
		TelaDespesas_lDescricao: 'Descrição',
		TelaDespesas_lData: 'Data',
		TelaDespesas_lDataPagamento: 'Data Pagamento',
		TelaDespesas_lPeriodo: 'Período',
		TelaDespesas_lValor: 'Valor',
		TelaDespesas_lQuantidade: 'Quantidade',
		TelaDespesas_lMotorista: 'Motorista',
		TelaDespesas_lTipoCombustivel: 'Tipo Combustível',
		TelaDespesas_lTanqueCombustivel: 'Tanque Combustível',
		TelaDespesas_lOdometro: 'Odômetro',
		TelaDespesas_lHorimetro: 'Horímetro',
		TelaDespesas_lNotaFiscal: 'Nota Fiscal',
		TelaDespesas_Msg1_PopupMotoristas: 'Selecione o motorista',
		TelaDespesas_Msg1_PopupRotas: 'Selecione a rota',
		TelaTanqueCombustivel_lNumero: 'Número',
		TelaTanqueCombustivel_lTipoCombustivel: 'Tipo Combustível',
		TelaTanqueCombustivel_lLocalizacao: 'Localização',
		TelaTanqueCombustivel_lCapacidade: 'Capacidade',
		TelaTanqueCombustivel_lEstoqueAtual: 'Estoque Atual',
		TelaTanqueCombustivel_lEstoqueMinimo: 'Estoque Mínimo',
		TelaTanqueCombustivel_lPrecoMedio: 'Preço Médio',
		TelaTanqueCombustivel_lDescricao: 'Descrição',
		TelaTanqueCombustivel_lCodigoSistemaTerceiro: 'Código do Sistema de Terceiro',
		TelaCompraCombustivel_lNotaFiscal: 'Nota Fiscal',
		TelaCompraCombustivel_lNumeroTanqueCombustivel: 'Número Tanque de Combustível',
		TelaCompraCombustivel_lFornecedor: 'Fornecedor',
		TelaCompraCombustivel_lTanqueCombustivel: 'Tanque de Combustível',
		TelaCompraCombustivel_lQuantidade: 'Quantidade',
		TelaCompraCombustivel_lValorTotal: 'Valor Total',
		TelaCompraCombustivel_lDataCompra: 'Data da Compra',
		TelaMovimentacaoCombustivel_lDataCompra: 'Data da Movimentação',
		TelaMovimentacaoCombustivel_lQuantidade: 'Quantidade',
		TelaMovimentacaoCombustivel_lNumeroTanqueCombustivelOrigem: 'Número Tanque de Combustível Origem',
		TelaMovimentacaoCombustivel_lNumeroTanqueCombustivelDestino: 'Número Tanque de Combustível Destino',
		TelaMovimentacaoCombustivel_lTanqueCombustivelOrigem: 'Tanque de Combustível Origem',
		TelaMovimentacaoCombustivel_lTanqueCombustivelDestino: 'Tanque de Combustível Destino',
		TelaPontoInteresse_lGrupo: 'Grupo',		
		TelaPontoInteresse_lCodigo: 'Código',
		TelaPontoInteresse_lNome: 'Nome',
		TelaPontoInteresse_lDescricao: 'Descrição',
		TelaPontoInteresse_lRaio: 'Raio',
		TelaPontoInteresse_lIdentificar: 'Identificar',
		TelaPontoInteresse_lEnviarAlerta: 'Enviar Alerta',
		TelaPontoInteresse_lInicioFimRota: 'Início/Fim Rota',
		TelaPontoInteresse_lIcone: 'Icone',
		TelaPontoInteresse_lTipo: 'Tipo',
		TelaPontoInteresse_lPoligono: 'Poligono',
		TelaPontoInteresse_lCirculo: 'Círculo',		
		TelaPontoInteresse_lLatitude: 'Latitude',
		TelaPontoInteresse_lLongitude: 'Longitude',
		TelaPontoInteresse_lRestricoes: 'Restrições',
		TelaPontoInteresse_lHorarioInicial: 'Horário Inicial',
		TelaPontoInteresse_lHorarioFinal: 'Horário Final',
		TelaPontoInteresse_lLimiteVelocidade: 'Limite Velocidade',
		TelaPontoInteresse_lAvisoTempoPermanencia: 'Aviso de Tempo de Permanência',
		TelaPontoInteresse_lAtivo: 'Ativo',
		TelaPontoInteresse_lFaixaPermanenciaVerde: 'Faixa Verde',
		TelaPontoInteresse_lFaixaPermanenciaAmarela: 'Faixa Amarela',
		TelaPontoInteresse_lFaixaPermanenciaVermelha: 'Faixa Vermelha',
		TelaPontoInteresse_lIntervaloEmMinutos: 'Intervalo em Minutos',
		TelaMensagemTeclado_lVeiculo: 'Veículo',
		TelaMensagemTeclado_lMotorista: 'Motorista',
		TelaMensagemTeclado_lTipoMensagem: 'Tipo',
		TelaMensagemTeclado_lMensagem: 'Mensagem',
		TelaMensagemTeclado_lTempoAlertaDescanso: 'Tempo para Alerta',
		TelaMensagemTeclado_lDataHora: 'Data/Hora',
		TelaMensagemTeclado_lLocalizacao: 'Localização',
		TelaMensagemTeclado_lJustificativa: 'Justificativa',
		TelaMensagemTeclado_Msg1_PopupMotoristas: ' Selecione o motorista do evento',
		TelaMensagemTeclado_lGerar: 'Gerar',
		TelaMensagemTeclado_lSenha: 'Senha',
		TelaMensagemTeclado_lContraSenha: 'Contra-Senha',
		TelaGrupoveiculo_lNome: 'Nome',
		TelaGrupoveiculo_lLogin: 'Login',
		TelaGrupoveiculo_lSenha: 'Senha',
		TelaGrupoveiculo_lDescricao: 'Descrição',
		TelaGrupoveiculo_lPermissoes: 'Permissões',
		TelaGrupoveiculo_lMaster: 'Master',
		TelaGrupoveiculo_lPodeSeAlterar: 'Pode se Alterar',
		TelaGrupoveiculo_lPodeBloquear: 'Pode Bloquear',
		TelaGrupoveiculo_lVisualizarRelatorios: 'Visualizar Relatórios',
		TelaGrupoveiculo_lVisualizarPercursos: 'Visualizar Percursos',
		TelaGrupoveiculo_lVisualizarAvisos: 'Visualizar Avisos',
		TelaGrupoveiculo_lVersaoSistema: 'Versão do Sistema',
		Menu_ControleViagens: 'Controle de Viagens',
		Menu_ControleEntradaSaida: 'Controle de Entrada e Saída',
		Menu_ControleRotasViagens: 'Rotas de Viagens',
		Menu_ControleZonasViagens: 'Zonas de Viagens',
		Menu_ControleEquipamentosViagens: 'Equipamentos de Viagens',
		Menu_ControleViagens_EventosMonitriip: 'Eventos do Monitriip',
		TelaZonasViagens_lNome: 'Nome',
		TelaControleViagemRapida_lPontoInteresse : 'Ponto de Interesse',
		TelaRotasControleViagem_lNome: 'Nome',
		TelaRotasControleViagem_msg1: 'Informe um endereço ou selecione um ponto de interesse',
		TelaRotasControleViagem_lNovoLocal: 'Endereço do Local',
		TelaRotasControleViagem_lPontoInteresse: 'Ponto de Interesse',
		TeleControleViagem_lStatusViagem: 'Status Viagem',
		TeleControleViagem_lDataViagem: 'Data',
		TeleControleViagem_lIdentificador: 'Identificador',
		TeleControleViagem_lMotorista: 'Motorista',
		TeleControleViagem_lAjudantes: 'Ajudantes',
		TeleControleViagem_lZona: 'Zona',
		TeleControleViagem_lDataSaida: 'Data de Saída',
		TeleControleViagem_lDataRetorno: 'Data de Retorno',
		TeleControleViagem_lPeriodo: 'Periodo',
		TeleControleViagem_lDe: 'DE',
		TeleControleViagem_lPara: 'PARA',
		TeleControleViagem_lRegiaoAtendida: 'Região Atendida',
		TeleControleViagem_lQtdCidades: 'Qtd Cidades',
		TeleControleViagem_lQtdEntregas: 'Qtd Entregas',
		TeleControleViagem_lPeso: 'Peso',
		TeleControleViagem_lValor: 'Valor',
		TeleControleViagem_lValorAdiantamento: 'Adiantamento Custo',
		TeleControleViagem_lDistancia: 'Distância',
		TeleControleViagem_lPolilinha: 'Trajeto',
		TeleControleViagem_BtnControleRota: 'Controlar Percurso ',
		TeleControleViagem_Msg_DeParaObrigatorio: 'Selecione o ínicio (DE) e o destino(PARA) da viagem para habilitar o controle do percurso ',
		TeleControleViagem_lPermitirIniciarAntesPlanejado: 'Permitir iniciar antes ',
		TeleControleViagem_lEquipamento: 'Equipamento',
		TeleControleViagem_lStatusAceiteMotoristaa: 'Aceite Motorista',
		TeleControleViagem_lPermitirSomenteComAceite: 'Iniciar somente com aceite',
		TeleControleViagem_lAlterarMotoristaNoVeiculo: 'Alterar motorista ao iniciar',
		TelaZonaRoteirizacao_lCodigo: 'Código',
		TelaZonaRoteirizacao_lNome: 'Nome',
		TelaZonaRoteirizacao_lPesoMinimo: 'Peso Mínimo',
		TelaZonaRoteirizacao_lMinimoPesoVeiculo: '% Mínimo Peso Veículo',
		TelaZonaRoteirizacao_lMaximoPesoVeiculo: '% Máximo Peso Veículo',
		TelaZonaRoteirizacao_lDesconsiderarDeslocamento: 'Desconsiderar deslocamento viagem',
		TelaZonaRoteirizacao_lListaVeiculos: 'Veículos permitidos',
		TelaZonaRoteirizacao_Msg_AreaZona: 'Área da zona incompleta',
		TelaZonaRoteirizacao_btnLimparZona: 'LimparZona',
		TelaZonaRoteirizacao_Msg_VeiculoJaExistente: 'Veículo já associado a zona',
		TelaZonaRoteirizacao_lTextoImportacao: 'Arquivo de zonas para importação',
		TelaZonaRoteirizacao_lImportacaoInstrucao: 'O arquivo CSV deve ter como separador o ; (ponto e virgula) e a sequencia de coluna é CODIGO ;  NOME . A primeira linha do arquivo é considerada como cabeçalho. ',
		TelaLojaRoteirizacao_lCodigo: 'Código',
		TelaLojaRoteirizacao_lNome: 'Nome',
		TelaLojaRoteirizacao_lSenha: 'Senha',
		TelaLojaRoteirizacao_BtnImportar: 'Importar',
		TelaLojaRoteirizacao_lTextoImportacao: 'Arquivo de lojas para importação',
		TelaLojaRoteirizacao_lImportacaoInstrucao: 'O arquivo CSV deve ter como separador o ; (ponto e virgula) e a sequencia de coluna é CODIGO ;  NOME . A primeira linha do arquivo é considerada como cabeçalho. ',
		TelaVendedorRoteirizacao_lCodigo: 'Código',
		TelaVendedorRoteirizacao_lNome: 'Nome',
		TelaVendedorRoteirizacao_lStatus: 'Status',
		TelaVendedorRoteirizacao_lSenhaAcesso: 'Senha',
		TelaVendedorRoteirizacao_lTextoImportacao: 'Arquivo de vendedores para importação',		
		TelaVendedorRoteirizacao_lImportacaoInstrucao: 'O arquivo CSV deve ter como separador o ; (ponto e virgula) e a sequencia de coluna é CODIGO ;  NOME . A primeira linha do arquivo é considerada como cabeçalho. ',
		TelaVendedorRoteirizacao_lEhArquivoControl: 'Arquivo do Contro ?',
		TelaVendedorRoteirizacao_BtnImportar: 'Importar',
		TelaTipoOcorrencia_lNome: 'Nome',
		TelaTipoOcorrencia_lErroMotorista: 'Erro do Motorista',
		TelaTipoOcorrencia_lErroConferente: 'Erro do Conferente',
		TelaTipoOcorrencia_lErroVendedor: 'Erro do Vendedor',
		TelaTipoOcorrencia_lPeso: 'Peso',
		TelaTipoOcorrencia_Msg_SelecioneUmaOpcao: 'Selecione pelo menos uma opção de tipo de erro',
		TelaPedido_lSemCelular: 'Sem celular',
		TelaPedido_lNaoRoteirizados: 'Não Roteirizados',
		TelaPedido_lVendedor: 'Vendedor',
		TelaPedido_lLoja: 'Loja',
		TelaPedido_lZona: 'Zona',
		TelaPedido_lStatus: 'Status',
		TelaPedido_lPedido: 'Pedido',
		TelaPedido_lCarregamento : 'Carregamento',
		TelaPedido_lLote: 'Lote',
		TelaPedido_lNumeroPedido: 'Número do Pedido',
		TelaPedido_lNumeroNotaFiscal: 'Número Nota Fiscal',
		TelaPedido_lNumeroCelular: 'Número Celular',
		TelaPedido_lData: 'Data',
		TelaPedido_lCompromissoEntrega: 'Compromisso de Entrega',
		TelaPedido_lRenegociacao: 'Renegocição da Entrega',
		TelaPedido_lQuantidade: 'Quantidade',
		TelaPedido_lValor: 'Valor',
		TelaPedido_lDescricao: 'Descrição',
		TelaPedido_lLiberadoParaSeparacao: 'Liberado para Separação',
		TelaPedido_lLiberadoParaRoteirizacao: 'Liberado para Roteirização',
		TelaPedido_lCliente: 'Cliente',
		TelaPedido_lEndereco: 'Endereço',
		TelaPedido_lRestricao: 'Restrições',
		TelaPedido_lPeso: 'Peso',
		TelaPedido_lVolume: 'Volume',
		TelaPedido_lHorarioAtendimento: 'Horário Disponível para Atendimento',
		TelaPedido_lHorarioAtendimentoInicial: 'Horário Inicial',
		TelaPedido_lHorarioAtendimentoFinal: 'Horário Final',
		TelaPedido_lTempoAtendimento: 'T. Atendimento',
		TelaEsqueciMinhaSenha_lTitulo: 'Esqueci Minha Senha',
		TelaEsqueciMinhaSenha_lSubTitulo: 'Informe o CPF/CNPJ e o email cadastrado',
		TelaEsqueciMinhaSenha_lCPFCNPJ: 'CPF/CNPJ',
		TelaEsqueciMinhaSenha_lEmail: 'E-mail',
		TelaEsqueciMinhaSenha_lRecuperarSenha: 'Recuperar Senha',
		TelaTrocarSenha_lTitulo: 'Alteração de Senha',
		TelaTrocarSenha_lSubTitulo: 'Informe os dados e clique em Gravar Nova Senha',
		TelaTrocarSenha_lCPFCNPJ: 'Informe o CPF/CNPJ',
		TelaTrocarSenha_lSenhaAtual: 'Seha atual',
		TelaTrocarSenha_lNovaSenha: 'Nova Senha',
		TelaTrocarSenha_lConfirmacaoNovaSenha: 'Confirmação nova senha',
		TelaTrocarSenha_BtnGravarNovaSenha: 'Gravar Nova Senha',
		TelaTrocarSenha_Msg_MinimoSenha: 'Senha deve ter pelo menos 5 caracteres',
		TelaTrocarSenha_Msg_ConfirmaSenhaDiferente: 'Confirmação está diferente da nova senha',
		TelaRoteirizacao_lVeiculo: 'Veículo',
		TelaRoteirizacao_lMotorista: 'Motorista',
		TeleRoteirizacao_lPedido: 'Pedido',
		TeleRoteirizacao_lCarregamento: 'Carregamento',
		TelaRoteirizacao_lStatus: 'Status',
		TelaRoteirizacao_lDataInicioPlanejada: 'Data Início',
		TelaRoteirizacao_lDataFimPlanejada: 'Data Fim',
		TelaRoteirizacao_lDataInicioRealizado: 'Data Início',
		TelaRoteirizacao_lDataFimRealizado: 'Data Fim',
		TelaRoteirizacao_lPoISaida: 'Ponto de Saída',
		TelaRoteirizacao_lPoIRetorno: 'Ponto de Retorno',
		TelaRoteirizacao_lDistanciaPrevista: 'Distancia Prevista',
		TelaRoteirizacao_lTempoEstimado: 'Tempo Estimado',
		TelaRoteirizacao_lValorDevolvido: 'Valor Devolvido',
		TelaRoteirizacao_lSincronizacao: 'Sincronização',
		TelaRoteirizacao_Btn_RemoveSincronizacao: 'Remover Sincronização',
		TelaRoteirizacao_Msg_RotaDoRoteirizador: 'Rota criada pelo roteirizador deve ser modificada pelo módulo de roteirização.',
		TelaRoteirizacao_lValor: 'Valor Transportado',
		TelaRoteirizacao_lQtdItinerarios: 'Quantidade de Itinerarios',
		TelaRoteirizacao_lPeso: 'Peso',
		TelaRoteirizacao_lVolume: 'Volume',
		TelaItinerario_lVendedor: 'Vendedor',
		TelaItinerario_lLoja: 'Loja',
		TelaItinerario_lZona: 'Zona',
		TelaItinerario_lStatus: 'Status',
		TelaItinerario_lCarregamento : 'Carregamento',
		TelaItinerario_lVeiculo: 'Veiculo',
		TelaItinerario_lMotorista: 'Motorista',
		TelaItinerario_lNumeroPedido: 'Número do Pedido',
		TelaItinerario_lNumeroNotaFiscal: 'Nota Fiscal',
		TelaItinerario_lDataPedido: 'Data do Pedido',
		TelaItinerario_lDataItinerario: 'Data do Itinerario',
		TelaItinerario_lQuantidade: 'Quantidade',
		TelaItinerario_lValor: 'Valor',
		TelaItinerario_lDescricao: 'Descrição',
		TelaItinerario_lCliente: 'Cliente',
		TelaItinerario_lEndereco: 'Endereço',
		TelaItinerario_lRestricao: 'Restrições',
		TelaItinerario_lPeso: 'Peso',
		TelaItinerario_lVolume: 'Volume',
		TelaItinerario_lHorarioAtendimento: 'Horário Disponível para Atendimento',
		TelaItinerario_lHorarioAtendimentoInicial: 'Horário Inicial',
		TelaItinerario_lHorarioAtendimentoFinal: 'Horário Final',
		TelaItinerario_lTempoAtendimento: 'T. Atendimento',
		TelaItinerario_lDataEntrega : 'Data da Entrega',
		TelaItinerario_lNotaTablet : 'Nota do Aplicativo',
		TelaItinerario_lNotaSMS : 'Nota do SMS',
		TelaItinerario_lTipoOcorrencia : 'Ocorrência',
		TelaRoteirizador_lListaPedidos: 'Lista de Pedidos',
		TelaRoteirizador_lLocalSaida: 'Local de saída',
		TelaRoteirizador_lLocalRetorno: 'Local de retorno',
		TelaRoteirizador_lDataRota: 'Data da Rota',
		TelaRoteirizador_lVeiculo: 'Veículos',
		TelaRoteirizador_lRestricoes: 'Restrições',
		TelaRoteirizador_lRestricoesPeso: 'Peso',
		TelaRoteirizador_lRestricoesVolume: 'Volume',
		TelaRoteirizador_lRestricoesZona: 'Zona',
		TelaRoteirizador_lRestricoesJanelaAtendimento: 'Janela de Atendimento',
		TelaRoteirizador_lRestricoesQtdMaxItens: 'Qtd Máx.Itens',
		TelaRoteirizador_lRestricoesAgruparZona: 'Agrupar Zona',
		TelaRoteirizador_lRestricoesAgruparVendedor: 'Agrupar Vendedor',
		TelaRoteirizador_lJornadaInicio: 'Jornada Início',
		TelaRoteirizador_lIntervaloIncio: 'Intervalo Início',
		TelaRoteirizador_lIntervaloFim: 'Intervalo Fim',
		TelaRoteirizador_lJornadaFim: 'Jornada Fim',
		TeleAlmoxarifadoPneu_lDescricao: 'Descrição',
		TeleFabricantePneu_lNome: 'Nome',
		TelaMotivoSucateamento_lDescricao: 'Descricao',
		TelaDimensaoPneu_lAplicacao: 'Aplicação',
		TelaDimensaoPneu_lLargura: 'Largura',
		TelaDimensaoPneu_lPerfil: 'Perfil',
		TelaDimensaoPneu_lAro: 'Aro',
		TelaDimensaoPneu_lRadial: 'Radial',
		TelaBandaRodagemPneu_lFabricante: 'Fabricante',
		TelaBandaRodagemPneu_lDescricao: 'Descrição',
		TelaBandaRodagemPneu_lTipoDesenho: 'Tipo Desenho',
		TelaModeloPneu_lDescricao: 'Descrição',
		TelaModeloPneu_lFabricante: 'Fabricante',		
		TelaModeloPneu_lDimensao: 'Dimensão',
		TelaModeloPneu_lSulco: 'Sulco',
		TelaModeloPneu_lSulcoMinimo: 'Sulco Mínimo',
		TelaModeloPneu_lPressaoRecomendada: 'Pressão Recomendada',
		TelaModeloPneu_lComCamera: 'Possui Camera',
		TelaModeloPneu_Msg_SulcoMinimoInvalido: 'O Sulco mínimo deve ser menor que o Sulco',
		TelaModeloPneu_lPressaoMinima: 'Pressão Mínima',
		TelaModeloPneu_lPressaoMaxima: 'Pressão Máxima',
		TelaPneu_lNumeroFogo: 'Numero de Fogo',
		TelaPneu_lDOT: 'DOT',
		TelaPneu_lSerie: 'Série',
		TelaPneu_lModelo: 'Modelo',
		TelaPneu_lDataMovimentacao: 'Data da Movimentação',
		TelaPneu_lTipoAquisicao: 'Tipo de Aquisição',
		TelaPneu_lVida: 'Vida',
		TelaPneu_lBandaRodagem : 'Banda de Rodagem',
		TelaPneu_lSulco: 'Sulco Atual',
		TelaPneu_lControladoPor: 'Controlado Por',
		TelaPneu_lKMRodado: 'Km Rodado',
		TelaPneu_lAlmoxarifado: 'Amoxarifado',
		TelaPneu_lFornecedor: 'Fornecedor',
		TelaPneu_lDocumentoNFE: 'Doc./NF-e',
		TelaPneu_lDataEmissaoDocumento: 'Emissão',
		TelaPneu_lValorUnitario: 'Valor',
		TelaPneu_lStatus: 'Status',
		TelaPneu_lVeiculo: 'Veículo',
		TelaInspecaoPneu_lNomeFogo: 'Número de Fogo',
		TelaInspecaoPneu_lFabricante: 'Fabricante',
		TelaInspecaoPneu_lModelo: 'Modelo',
		TelaInspecaoPneu_lData: 'Data',
		TelaInspecaoPneu_lOdometro: "Odômetro (km)",
		TelaInspecaoPneu_lPressao: 'Pressão Aferida',
		TelaInspecaoPneu_lPressaoRecomendada: 'Pressão Recomendada',
		TelaInspecaoPneu_lSulcoAtual_Medida1: 'Sulco Atual - Medida 1',
		TelaInspecaoPneu_lSulcoAtual_Medida2: 'Sulco Atual - Medida 2',
		TelaInspecaoPneu_lSulcoAtual_Medida3: 'Sulco Atual - Medida 3',
		TelaInspecaoPneu_lSulcoMinimo: 'Sulco Mínimo',
		TelaInspecaoPneu_Msg_Instrucao: 'Clique no pneu desejado para informar os dados da inspeção',
		TeleTipoDespesa_lTipo: 'Tipo',
		TelaTipoReceita_lTipo: 'Tipo',
		TeleEquipamentoViagem_lTipo: 'Tipo',
		TeleEquipamentoViagem_lPlaca: 'Placa',
		TeleEquipamentoViagem_lStatus: 'Status',
		TeleEventoMonitriip_lVeiculo: 'Veículo',
		TeleEventoMonitriip_lOperacao: 'Operação',
		TeleEventoMonitriip_lDataHora: 'Data/Hora',
		TeleEventoMonitriip_lIMEI : 'IMEI',
		TeleEventoMonitriip_lLatitude : 'Latitude',
		TeleEventoMonitriip_lLongitude : 'Longitude',
		TeleEventoMonitriip_lCPFMotorista : 'CPF Motorista',
		TeleEventoMonitriip_lTipoEvento : 'Tipo Evento',
		TeleEventoMonitriip_lAutorizacaoViagem : 'Autorização Viagem',
		TeleEventoMonitriip_lTipoRegistroViagem : 'Tipo Registro Viagem',
		TeleEventoMonitriip_lMotivoParada : 'Motivo Parada',
		TeleEventoMonitriip_lTipoRegistroEvento : 'Tipo Registro Evento',
		TeleEventoMonitriip_lSentidoLinha : 'Sentido Linha',
		TeleEventoMonitriip_lIdentificacaoLinha : 'Identificação Linha',
		TeleEventoMonitriip_lCodigoTipoViagem : 'Código Tipo Viagem',
		TeleEventoMonitriip_lDataProgramaViagem : 'Data Programada Viagem',
		TeleEventoMonitriip_lHoraProgramadaViagem : 'Hora Programada Viagem',
		TeleEventoMonitriip_lDataRecebimento : 'Data Recebimento',
		TeleEventoMonitriip_lDataEnvioANTT : 'Data envio ANTT',
		TeleEventoMonitriip_lProcessado : 'Processado',
		TelaTipoItemAgendaEvento_codigo : 'Código',
		TelaTipoItemAgendaEvento_descricao : 'Descrição',
		TelaGrupoDespesa_codigo : 'Código',
		TelaGrupoDespesa_nome : 'Nome',
		TelaGrupoReceita_codigo : 'Código',
		TelaGrupoReceita_nome : 'Nome',	
		TelaSomAviso_lTipoAviso: 'Tipo do Aviso',
		TelaSomAviso_lNomeArquivoSom: 'Som',
		Menu_ControleEstoque_CategoriaProduto: 'Categorias de Peças',
		TelaControleEstoque_CategoriaProduto_lNome: 'Nome',
		TelaControleEstoque_CategoriaProduto_lDescricao: 'Descrição',
		Menu_ControleEstoque_Deposito: 'Depósitos de Peças',		
		TelaControleEstoque_Deposito_lNome: 'Nome',
		TelaControleEstoque_Deposito_lDesconsiderarSaldo: 'Desconsiderar Saldo',
		Menu_ControleEstoque_Produto: 'Peças',
		TelaControleEstoque_Produto_lCategoria: 'Categoria',
		TelaControleEstoque_Produto_lCodigo: 'Código',
		TelaControleEstoque_Produto_lNome: 'Nome',
		TelaControleEstoque_Produto_lDescricao: 'Descrição',
		TelaControleEstoque_Produto_lEstoqueMinimo: 'Estoque Mínimo',
		TelaControleEstoque_Produto_lEstoqueMaximo: 'Estoque Máximo',
		TelaControleEstoque_Produto_lSaldoAtual: 'Estoque Atual',
		TelaControleEstoque_Produto_lUnidadeDeMedida: 'Unidade de Medida',
		TelaControleEstoque_Produto_lDataHoraUltimaAtualizacao: 'Ultima Atualização',
		TelaControleEstoque_Produto_lStatus: 'Status',
		Menu_ControleEstoque_ComprasProduto: 'Compras de Peças',
		TelaControleEstoque_ComprasProduto_lFornecedor: 'Fornecedor',
		TelaControleEstoque_ComprasProduto_lDeposito: 'Depósito',
		TelaControleEstoque_ComprasProduto_lData: 'Data',
		TelaControleEstoque_ComprasProduto_lNotaFiscal: 'Nota Fiscal',
		TelaControleEstoque_ComprasProduto_lObservacao: 'Observação',
		TelaControleEstoque_ComprasProduto_lValor: 'Valor',
		TelaControleEstoque_ComprasProduto_lProduto: 'Peça',
		TelaControleEstoque_ComprasProduto_lQtd: 'Quantidade',
		TelaControleEstoque_ComprasProduto_lValorUnitario: 'Valor Unitário',
		Menu_ControleEstoque_MovimentacaoEstoque: 'Movimentação de Estoque',
		TelaControleEstoque_MovimentacaoEstoque_lTipoMovimentacao: 'Tipo Movimentação',
		TelaControleEstoque_MovimentacaoEstoque_lData: 'Data',
		TelaControleEstoque_MovimentacaoEstoque_lDepositoOrigem: 'Depósito Origem',
		TelaControleEstoque_MovimentacaoEstoque_lDepositoDestino: 'Depósito Destino',
		TelaControleEstoque_MovimentacaoEstoque_lObservacao: 'Observação',
		TelaControleEstoque_MovimentacaoEstoque_lVeiculoOrigem: 'Veículo Origem',
		TelaControleEstoque_MovimentacaoEstoque_lVeiculoDestino: 'Veículo Destino',
		TelaTipoOcorrenciasVeiculo_lNome: 'Nome',
		TelaTipoOcorrenciasVeiculo_lAtivo: 'Ativo',
		TelaOcorrenciasVeiculo_lVeiculo: 'Veiculo',
		TelaOcorrenciasVeiculo_lMotorista: 'Motorista',
		TelaOcorrenciasVeiculo_lTipoOcorrencia: 'Tipo da Ocorrência',
		TelaOcorrenciasVeiculo_lDataHora: 'Data/Hora',
		TelaOcorrenciasVeiculo_lDescricao: 'Descrição',
		TelaOcorrenciasVeiculo_lStatus: 'Status',
		TelaOcorrenciasVeiculo_lDataHoraCadastro: 'Data/Hora do Cadastro',
		TelaModeloCheckList_codigo : 'Nome',
		TelaModeloCheckList_descricao : 'Descrição',
		TelaModeloCheckList_ativo : 'Ativo',
		TelaModeloCheckList_dataCriacao : 'Criado',
		TelaModeloCheckList_dataAlteracao : 'Alterado',
		TelaItemModeloCheckList_nome : 'Titulo',
		TelaItemModeloCheckList_descricao : 'Descrição',
		TelaItemModeloCheckList_obrigatorio : 'Obrigatório',
		TelaItemModeloCheckList_exigirFotoSeReprovado : 'Exigir Foto',
		TelaItemModeloCheckList_exigirObservacaoSeReprovado : 'Exigir Observação',
		TelaItemModeloCheckList_abrirOcorrenciaSeReprovado : 'Abrir Ocorrência',
		TelaItemModeloCheckList_exigirFotoSeAprovado : 'Exigir Foto',
		TelaItemModeloCheckList_exigirObservacaoSeAprovado : 'Exigir Observação',
		TelaItemModeloCheckList_abrirOcorrenciaSeAprovado : 'Abrir Ocorrência',
		TelaItemModeloCheckList_seReprovado : 'Se reprovado',
		TelaItemModeloCheckList_seAprovado : 'Se Aprovado',
		TelaVeiculoExterno_marca: 'Marca',
		TelaVeiculoExterno_modelo: 'Modelo',
		TelaVeiculoExterno_placa: 'Placa',
		TelaVeiculoExterno_cor: 'Cor',
		TelaVeiculoExterno_nomeMotorista: 'Nome Motorista',
		TelaVeiculoExterno_ativo: 'Ativo',
		TelaVeiculoExterno_dataHoraCadastro: 'Data/Hora Cadastro',
		TelaVeiculoExterno_usuario: 'Usuário',
		TelaPerfilCoresVelocidadePercurso_nome: 'Nome',
		TelaPerfilCoresVelocidadePercurso_velocidadeFaixa1: ' Velocidade Faixa 1',
		TelaPerfilCoresVelocidadePercurso_velocidadeFaixa2: ' Velocidade Faixa 2',
		TelaPerfilCoresVelocidadePercurso_velocidadeFaixa3: ' Velocidade Faixa 3',
		TelaPerfilCoresVelocidadePercurso_velocidadeFaixa1Inicio: ' Velocidade Inicio Faixa 1',
		TelaPerfilCoresVelocidadePercurso_velocidadeFaixa2Inicio: ' Velocidade Inicio Faixa 2',
		TelaPerfilCoresVelocidadePercurso_velocidadeFaixa3Inicio: ' Velocidade Inicio Faixa 3',
		TelaPerfilCoresVelocidadePercurso_velocidadeFaixa1Fim: ' Velocidade Fim Faixa 1',
		TelaPerfilCoresVelocidadePercurso_velocidadeFaixa2Fim: ' Velocidade Fim Faixa 2',
		TelaPerfilCoresVelocidadePercurso_velocidadeFaixa3Fim: ' Velocidade Fim Faixa 3',
		Mensagem_Erro_Intersecao_Faixa1_Faixa2: "A velocidade final da Faixa 1 não pode ser maior ou igual à velocidade inicial da Faixa 2.",
		Mensagem_Erro_Intersecao_Faixa2_Faixa3: "A velocidade final da Faixa 2 não pode ser maior ou igual à velocidade inicial da Faixa 3.",
		Mensagem_Erro_Ordem_Faixa1: "A velocidade inicial da Faixa 1 deve ser menor que a velocidade final.",
		Mensagem_Erro_Ordem_Faixa2: "A velocidade inicial da Faixa 2 deve ser menor que a velocidade final.",
		Mensagem_Erro_Ordem_Faixa3: "A velocidade inicial da Faixa 3 deve ser menor que a velocidade final."  
	}
}

